(window.theme = window.theme || {}),
  (window.theme = window.theme || {}),
  (theme.Sections = function () {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
      var $container = $(container),
        id = $container.attr("data-section-id"),
        type = $container.attr("data-section-type");
      if (
        ((constructor = constructor || this.constructors[type]),
        !_.isUndefined(constructor))
      ) {
        var instance = _.assignIn(new constructor(container), {
          id,
          type,
          container,
        });
        this.instances.push(instance);
      }
    },
    _onSectionLoad: function (evt) {
      var container = $("[data-section-id]", evt.target)[0];
      container && this._createInstance(container);
    },
    _onSectionUnload: function (evt) {
      this.instances = _.filter(this.instances, function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
        return (
          isEventInstance &&
            _.isFunction(instance.onUnload) &&
            instance.onUnload(evt),
          !isEventInstance
        );
      });
    },
    _onSelect: function (evt) {
      var instance = _.find(this.instances, function (instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      !_.isUndefined(instance) &&
        _.isFunction(instance.onSelect) &&
        instance.onSelect(evt);
    },
    _onDeselect: function (evt) {
      var instance = _.find(this.instances, function (instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      !_.isUndefined(instance) &&
        _.isFunction(instance.onDeselect) &&
        instance.onDeselect(evt);
    },
    _onBlockSelect: function (evt) {
      var instance = _.find(this.instances, function (instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      !_.isUndefined(instance) &&
        _.isFunction(instance.onBlockSelect) &&
        instance.onBlockSelect(evt);
    },
    _onBlockDeselect: function (evt) {
      var instance = _.find(this.instances, function (instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      !_.isUndefined(instance) &&
        _.isFunction(instance.onBlockDeselect) &&
        instance.onBlockDeselect(evt);
    },
    register: function (type, constructor) {
      (this.constructors[type] = constructor),
        $("[data-section-type=" + type + "]").each(
          function (index, container) {
            this._createInstance(container, constructor);
          }.bind(this)
        );
    },
  })),
  (window.slate = window.slate || {}),
  (slate.rte = {
    wrapTable: function () {
      $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
    },
    iframeReset: function () {
      var $iframeVideo = $(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe[data-src*="youtube.com/embed"] '
        ),
        $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");
      $iframeVideo.each(function () {
        $(this).wrap('<div class="video-wrapper"></div>');
      }),
        $iframeReset.each(function () {
          this.src = this.src;
        });
    },
  }),
  (window.slate = window.slate || {}),
  (slate.a11y = {
    pageLinkFocus: function ($element) {
      var focusClass = "js-focus-hidden";
      $element
        .first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass(focusClass)
        .one("blur", callback);
      function callback() {
        $element.first().removeClass(focusClass).removeAttr("tabindex");
      }
    },
    focusHash: function () {
      var hash = window.location.hash;
      hash &&
        document.getElementById(hash.slice(1)) &&
        this.pageLinkFocus($(hash));
    },
    bindInPageLinks: function () {
      $("a[href*=#]").on(
        "click",
        function (evt) {
          this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";
      options.$elementToFocus || (options.$elementToFocus = options.$container),
        options.$container.attr("tabindex", "-1"),
        options.$elementToFocus.focus(),
        $(document).off("focusin"),
        $(document).on(eventName, function (evt) {
          options.$container[0] !== evt.target &&
            !options.$container.has(evt.target).length &&
            options.$container.focus();
        });
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";
      options.$container &&
        options.$container.length &&
        options.$container.removeAttr("tabindex"),
        $(document).off(eventName);
    },
  }),
  (theme.Images = (function () {
    function preload(images, size) {
      typeof images == "string" && (images = [images]);
      for (var i2 = 0; i2 < images.length; i2++) {
        var image = images[i2];
        this.loadImage(this.getSizedImageUrl(image, size));
      }
    }
    function loadImage(path) {
      new Image().src = path;
    }
    function switchImage(image, element, callback) {
      var size = this.imageSize(element.src),
        imageUrl = this.getSizedImageUrl(image.src, size);
      callback ? callback(imageUrl, image, element) : (element.src = imageUrl);
    }
    function imageSize(imageSize2) {
      if (typeof src < "u") {
        var match = src.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
        );
        if (match !== null) return match[1];
      } else return null;
    }
    function getSizedImageUrl(src2, size) {
      if (size == null) return src2;
      if (size === "master") return this.removeProtocol(src2);
      if (src2 != null)
        var match = src2.match(
          /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );
      if (match != null) {
        var prefix = src2.split(match[0]),
          suffix = match[0];
        return this.removeProtocol(prefix[0] + "_" + size + suffix);
      }
      return null;
    }
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }
    return { switchImage, imageSize, getSizedImageUrl, removeProtocol };
  })()),
  (theme.Currency = (function () {
    var moneyFormat = "${{amount}}";
    function formatMoney(cents, format) {
      typeof cents == "string" && (cents = cents.replace(".", ""));
      var value = "",
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || moneyFormat;
      function formatWithDelimiters(number, precision, thousands, decimal) {
        if (
          ((precision = precision || 2),
          (thousands = thousands || ","),
          (decimal = decimal || "."),
          isNaN(number) || number == null)
        )
          return 0;
        number = (number / 100).toFixed(precision);
        var parts = number.split("."),
          dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
    return { formatMoney };
  })()),
  (theme.handleize = function (text) {
    return text
      .toLowerCase()                    // Convert to lowercase
      .replace(/[^\w\s-]/g, '')         // Remove all non-word, non-space, non-hyphen characters
      .replace(/\s+/g, '-')             // Replace spaces with a single hyphen
      .replace(/-+/g, '-')              // Replace multiple hyphens with a single hyphen
      .replace(/^-+/, '')               // Trim hyphens from the start
      .replace(/-+$/, '');              // Trim hyphens from the end
  }),
  (slate.Variants = (function () {
    function Variants(options) {
      (this.$container = options.$container),
        (this.product = options.product),
        (this.singleOptionSelector = options.singleOptionSelector),
        (this.originalSelectorId = options.originalSelectorId),
        (this.enableHistoryState = options.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on(
          "change",
          this._onSelectChange.bind(this)
        );
    }
    return (
      (Variants.prototype = _.assignIn({}, Variants.prototype, {
        _getCurrentOptions: function () {
          var currentOptions = _.map(
            $(this.singleOptionSelector, this.$container),
            function (element) {
              var $element = $(element),
                type = $element.attr("type"),
                currentOption = {};
              return type === "radio" || type === "checkbox"
                ? $element[0].checked
                  ? ((currentOption.value = $element.val()),
                    (currentOption.index = $element.data("index")),
                    currentOption)
                  : !1
                : ((currentOption.value = $element.val()),
                  (currentOption.index = $element.data("index")),
                  currentOption);
            }
          );
          return (currentOptions = _.compact(currentOptions)), currentOptions;
        },
        _getVariantFromOptions: function () {
          var selectedValues = this._getCurrentOptions(),
            variants = this.product.variants,
            found = _.find(variants, function (variant) {
              return selectedValues.every(function (values) {
                return _.isEqual(variant[values.index], values.value);
              });
            });
          return found;
        },
        _onSelectChange: function () {
          var variant = this._getVariantFromOptions();
          this.$container.trigger({ type: "variantChange", variant }),
            variant &&
              (this._updateMasterSelect(variant),
              this._updateImages(variant),
              this._updatePrice(variant),
              this._updateSKU(variant),
              (this.currentVariant = variant),
              this.enableHistoryState && this._updateHistoryState(variant));
        },
        _updateImages: function (variant) {
          var variantImage = variant.featured_image || {},
            currentVariantImage = this.currentVariant.featured_image || {};
          !variant.featured_image ||
            variantImage.src === currentVariantImage.src ||
            this.$container.trigger({ type: "variantImageChange", variant });
        },
        _updatePrice: function (variant) {
          (variant.price === this.currentVariant.price &&
            variant.compare_at_price ===
              this.currentVariant.compare_at_price) ||
            this.$container.trigger({ type: "variantPriceChange", variant });
        },
        _updateSKU: function (variant) {
          variant.sku !== this.currentVariant.sku &&
            this.$container.trigger({ type: "variantSKUChange", variant });
        },
        _updateHistoryState: function (variant) {
          if (!(!history.replaceState || !variant)) {
            var newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
          }
        },
        _updateMasterSelect: function (variant) {
          $(this.originalSelectorId, this.$container).val(variant.id);
        },
      })),
      Variants
    );
  })()),
  (theme.Drawers = (function () {
    function Drawer(id, position, options) {
      var defaults = {
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + position,
        openClass: "js-drawer-open",
        dirOpenClass: "js-drawer-open-" + position,
      };
      if (
        ((this.nodes = {
          $parent: $("html").add("body"),
          $page: $("#PageContainer"),
        }),
        (this.config = $.extend(defaults, options)),
        (this.position = position),
        (this.$drawer = $("#" + id)),
        !this.$drawer.length)
      )
        return !1;
      (this.drawerIsOpen = !1), this.init();
    }
    return (
      (Drawer.prototype.init = function () {
        $(this.config.open).on("click", $.proxy(this.open, this)),
          this.$drawer.on(
            "click",
            this.config.close,
            $.proxy(this.close, this)
          );
      }),
      (Drawer.prototype.open = function (evt) {
        var externalCall = !1;
        return (
          evt ? evt.preventDefault() : (externalCall = !0),
          evt &&
            evt.stopPropagation &&
            (evt.stopPropagation(),
            (this.$activeSource = $(evt.currentTarget))),
          this.drawerIsOpen && !externalCall
            ? this.close()
            : (this.$drawer.prepareTransition(),
              this.nodes.$parent.addClass(
                this.config.openClass + " " + this.config.dirOpenClass
              ),
              (this.drawerIsOpen = !0),
              slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus",
              }),
              this.config.onDrawerOpen &&
                typeof this.config.onDrawerOpen == "function" &&
                (externalCall || this.config.onDrawerOpen()),
              this.$activeSource &&
                this.$activeSource.attr("aria-expanded") &&
                this.$activeSource.attr("aria-expanded", "true"),
              this.bindEvents(),
              this)
        );
      }),
      (Drawer.prototype.close = function () {
        this.drawerIsOpen &&
          ($(document.activeElement).trigger("blur"),
          this.$drawer.prepareTransition(),
          this.nodes.$parent.removeClass(
            this.config.dirOpenClass + " " + this.config.openClass
          ),
          (this.drawerIsOpen = !1),
          slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus",
          }),
          this.unbindEvents());
      }),
      (Drawer.prototype.bindEvents = function () {
        this.nodes.$parent.on(
          "keyup.drawer",
          $.proxy(function (evt) {
            return evt.keyCode === 27 ? (this.close(), !1) : !0;
          }, this)
        ),
          this.nodes.$page.on("touchmove.drawer", function () {
            return !1;
          }),
          this.nodes.$page.on(
            "click.drawer",
            $.proxy(function () {
              return this.close(), !1;
            }, this)
          );
      }),
      (Drawer.prototype.unbindEvents = function () {
        this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
      }),
      Drawer
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.Header = (function () {
    var selectors = {
        body: "body",
        navigation: "#AccessibleNav",
        siteNavHasDropdown: ".site-nav--has-dropdown",
        siteNavChildLinks: ".site-nav__child-link",
        siteNavActiveDropdown: ".site-nav--active-dropdown",
        siteNavLinkMain: ".site-nav__link--main",
        siteNavChildLink: ".site-nav__link--last",
      },
      config = {
        activeClass: "site-nav--active-dropdown",
        childLinkClass: "site-nav__child-link",
      },
      cache = {};
    function init() {
      cacheSelectors(),
        cache.$parents.on("click.siteNav", function (evt) {
          var $el = $(this);
          $el.hasClass(config.activeClass) ||
            (evt.preventDefault(), evt.stopImmediatePropagation()),
            showDropdown($el);
        }),
        $(selectors.siteNavChildLink).on("focusout.siteNav", function () {
          setTimeout(function () {
            $(document.activeElement).hasClass(config.childLinkClass) ||
              !cache.$activeDropdown.length ||
              hideDropdown(cache.$activeDropdown);
          });
        }),
        cache.$topLevel.on("focus.siteNav", function () {
          cache.$activeDropdown.length && hideDropdown(cache.$activeDropdown);
        }),
        cache.$subMenuLinks.on("click.siteNav", function (evt) {
          evt.stopImmediatePropagation();
        });
    }
    function cacheSelectors() {
      cache = {
        $nav: $(selectors.navigation),
        $topLevel: $(selectors.siteNavLinkMain),
        $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
        $subMenuLinks: $(selectors.siteNavChildLinks),
        $activeDropdown: $(selectors.siteNavActiveDropdown),
      };
    }
    function showDropdown($el) {
      $el.addClass(config.activeClass),
        cache.$activeDropdown.length && hideDropdown(cache.$activeDropdown),
        (cache.$activeDropdown = $el),
        $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "true"),
        setTimeout(function () {
          $(window).on("keyup.siteNav", function (evt) {
            evt.keyCode === 27 && hideDropdown($el);
          }),
            $(selectors.body).on("click.siteNav", function () {
              hideDropdown($el);
            });
        }, 250);
    }
    function hideDropdown($el) {
      $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "false"),
        $el.removeClass(config.activeClass),
        (cache.$activeDropdown = $(selectors.siteNavActiveDropdown)),
        $(selectors.body).off("click.siteNav"),
        $(window).off("keyup.siteNav");
    }
    function unload() {
      $(window).off(".siteNav"),
        cache.$parents.off(".siteNav"),
        cache.$subMenuLinks.off(".siteNav"),
        cache.$topLevel.off(".siteNav"),
        $(selectors.siteNavChildLink).off(".siteNav"),
        $(selectors.body).off(".siteNav");
    }
    return { init, unload };
  })()),
  (window.theme = window.theme || {}),
  (theme.MobileNav = (function () {
    var classes = {
        mobileNavOpenIcon: "mobile-nav--open",
        mobileNavCloseIcon: "mobile-nav--close",
        subNavLink: "mobile-nav__sublist-link",
        return: "mobile-nav__return-btn",
        subNavActive: "is-active",
        subNavClosing: "is-closing",
        navOpen: "js-menu--is-open",
        subNavShowing: "sub-nav--is-open",
        thirdNavShowing: "third-nav--is-open",
        subNavToggleBtn: "js-toggle-submenu",
      },
      cache = {},
      isTransitioning,
      $activeSubNav,
      $activeTrigger,
      menuLevel = 1,
      mediaQuerySmall = "screen and (max-width: 749px)";
    function init() {
      cacheSelectors(),
        cache.$mobileNavToggle.on("click", toggleMobileNav),
        cache.$subNavToggleBtn.on("click.subNav", toggleSubNav),
        enquire.register(mediaQuerySmall, {
          unmatch: function () {
            closeMobileNav();
          },
        });
    }
    function toggleMobileNav() {
      cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)
        ? closeMobileNav()
        : openMobileNav();
    }
    function cacheSelectors() {
      cache = {
        $pageContainer: $("#PageContainer"),
        $siteHeader: $(".site-header"),
        $mobileNavToggle: $(".js-mobile-nav-toggle"),
        $mobileNavContainer: $(".mobile-nav-wrapper"),
        $mobileNav: $("#MobileNav"),
        $subNavToggleBtn: $("." + classes.subNavToggleBtn),
        $subNavReturnBtn: $("." + classes.return),
      };
    }
    function openMobileNav() {
      var translateHeaderHeight =
          cache.$siteHeader.outerHeight() + cache.$siteHeader.offset().top,
        fixedNavTranslateHeaderHeight = cache.$siteHeader.outerHeight();
      cache.$mobileNavContainer.css("height", "100vh"),
        cache.$mobileNavContainer.animate({ opacity: "100%" }, 100),
        slate.a11y.trapFocus({
          $container: cache.$mobileNav,
          namespace: "navFocus",
        }),
        cache.$mobileNavToggle
          .addClass(classes.mobileNavCloseIcon)
          .removeClass(classes.mobileNavOpenIcon);
    }
    function closeMobileNav() {
      cache.$subNavReturnBtn.click(),
        cache.$mobileNavContainer.animate({ opacity: "0" }, 100, function () {
          cache.$mobileNavContainer.css("height", "0");
        }),
        cache.$mobileNavContainer.one(
          "TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle",
          function () {
            slate.a11y.removeTrapFocus({
              $container: cache.$mobileNav,
              namespace: "navFocus",
            });
          }
        ),
        cache.$mobileNavToggle
          .addClass(classes.mobileNavOpenIcon)
          .removeClass(classes.mobileNavCloseIcon),
        $(window).off("keyup.mobileNav");
    }
    function toggleSubNav(evt) {
      if (!isTransitioning) {
        var $toggleBtn = $(evt.currentTarget),
          isReturn = $toggleBtn.hasClass(classes.return);
        (isTransitioning = !0),
          isReturn
            ? ($(
                "." +
                  classes.subNavToggleBtn +
                  '[data-level="' +
                  (menuLevel - 1) +
                  '"]'
              ).removeClass(classes.subNavActive),
              $activeTrigger &&
                $activeTrigger.length &&
                $activeTrigger.removeClass(classes.subNavActive))
            : $toggleBtn.addClass(classes.subNavActive),
          ($activeTrigger = $toggleBtn),
          goToSubnav($toggleBtn.data("target"));
      }
    }
    function goToSubnav(target) {
      var $targetMenu = target
        ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
        : cache.$mobileNav;
      (menuLevel = $targetMenu.data("level") ? $targetMenu.data("level") : 1),
        $activeSubNav &&
          $activeSubNav.length &&
          $activeSubNav.prepareTransition().addClass(classes.subNavClosing),
        ($activeSubNav = $targetMenu);
      var $elementToFocus = target
          ? $targetMenu.find("." + classes.subNavLink + ":first")
          : $activeTrigger,
        translateMenuHeight = $targetMenu[0].scrollHeight;
      target || (translateMenuHeight = $targetMenu.outerHeight());
      var openNavClass =
        menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
      cache.$mobileNavContainer
        .css("height", translateMenuHeight + 38)
        .removeClass(classes.thirdNavShowing)
        .addClass(openNavClass),
        target ||
          cache.$mobileNavContainer
            .removeClass(classes.thirdNavShowing)
            .removeClass(classes.subNavShowing),
        cache.$mobileNavContainer.one(
          "TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle",
          function () {
            cache.$mobileNavContainer.off(".subnavToggle"),
              (isTransitioning = !1);
          }
        ),
        $activeSubNav.removeClass(classes.subNavClosing);
    }
    return { init, closeMobileNav, toggleSubNav };
  })(jQuery)),
  (window.theme = window.theme || {}),
  (theme.Search = (function () {
    var selectors = {
        search: ".search",
        searchSubmit: ".search__submit",
        searchInput: ".search__input",
        siteHeader: ".site-header",
        siteHeaderSearchToggle: ".site-header__search-toggle",
        siteHeaderSearch: ".site-header__search",
        searchDrawer: ".search-bar",
        searchDrawerInput: ".search-bar__input",
        searchHeader: ".search-header",
        searchHeaderInput: ".search-header__input",
        searchHeaderSubmit: ".search-header__submit",
        mobileNavWrapper: ".mobile-nav-wrapper",
      },
      classes = { focus: "search--focus", mobileNavIsOpen: "js-menu--is-open" };
    function init() {
      $(selectors.siteHeader).length &&
        (initDrawer(),
        searchSubmit(),
        $(selectors.searchHeaderInput)
          .add(selectors.searchHeaderSubmit)
          .on("focus blur", function () {
            $(selectors.searchHeader).toggleClass(classes.focus);
          }),
        $(selectors.siteHeaderSearchToggle).on("click", function () {
          var searchHeight = $(selectors.siteHeader).outerHeight(),
            searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
          $(selectors.searchDrawer).css({
            height: searchHeight + "px",
            top: searchOffset + "px",
          });
        }));
    }
    function initDrawer() {
      $("#PageContainer").addClass("drawer-page-content"),
        $(".js-drawer-open-top")
          .attr("aria-controls", "SearchDrawer")
          .attr("aria-expanded", "false"),
        (theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
          onDrawerOpen: searchDrawerFocus,
        }));
    }
    function searchDrawerFocus() {
      searchFocus($(selectors.searchDrawerInput)),
        $(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen) &&
          theme.MobileNav.closeMobileNav();
    }
    function searchFocus($el) {
      $el.focus(), $el[0].setSelectionRange(0, $el[0].value.length);
    }
    function searchSubmit() {
      $(selectors.searchSubmit).on("click", function (evt) {
        var $el = $(evt.target),
          $input = $el.parents(selectors.search).find(selectors.searchInput);
        $input.val().length === 0 &&
          (evt.preventDefault(), searchFocus($input));
      });
    }
    return { init };
  })()),
  (function () {
    var selectors = { backButton: ".return-link" },
      $backButton = $(selectors.backButton);
    if (!document.referrer || !$backButton.length || !window.history.length)
      return;
    $backButton.one("click", function (evt) {
      evt.preventDefault();
      var referrerDomain = urlDomain(document.referrer),
        shopDomain = urlDomain(window.location.href);
      return shopDomain === referrerDomain && history.back(), !1;
    });
    function urlDomain(url) {
      var anchor = document.createElement("a");
      return (anchor.ref = url), anchor.hostname;
    }
  })(),
  (theme.Slideshow = (function () {
    this.$slideshow = null;
    var classes = {
      wrapper: "slideshow-wrapper",
      slideshow: "slideshow",
      currentSlide: "slick-current",
      video: "slideshow__video",
      videoBackground: "slideshow__video--background",
      closeVideoBtn: "slideshow__video-control--close",
      pauseButton: "slideshow__pause",
      isPaused: "is-paused",
    };
    function slideshow(el) {
      (this.$slideshow = $(el)),
        (this.$wrapper = this.$slideshow.closest("." + classes.wrapper)),
        (this.$pause = this.$wrapper.find("." + classes.pauseButton)),
        (this.settings = {
          accessibility: !0,
          arrows: !1,
          dots: !0,
          fade: !0,
          draggable: !0,
          touchThreshold: 20,
          autoplay: this.$slideshow.data("autoplay"),
          autoplaySpeed: this.$slideshow.data("speed"),
        }),
        this.$slideshow.on("beforeChange", beforeChange.bind(this)),
        this.$slideshow.on("init", slideshowA11y.bind(this)),
        this.$slideshow.slick(this.settings),
        this.$pause.on("click", this.togglePause.bind(this));
    }
    function slideshowA11y(event, obj) {
      var $slider = obj.$slider,
        $list = obj.$list,
        $wrapper = this.$wrapper,
        autoplay = this.settings.autoplay;
      $list.removeAttr("aria-live"),
        $wrapper.on("focusin", function (evt) {
          $wrapper.has(evt.target).length &&
            ($list.attr("aria-live", "polite"),
            autoplay && $slider.slick("slickPause"));
        }),
        $wrapper.on("focusout", function (evt) {
          if (
            $wrapper.has(evt.target).length &&
            ($list.removeAttr("aria-live"), autoplay)
          ) {
            if ($(evt.target).hasClass(classes.closeVideoBtn)) return;
            $slider.slick("slickPlay");
          }
        }),
        obj.$dots &&
          obj.$dots.on("keydown", function (evt) {
            evt.which === 37 && $slider.slick("slickPrev"),
              evt.which === 39 && $slider.slick("slickNext"),
              (evt.which === 37 || evt.which === 39) &&
                obj.$dots.find(".slick-active button").focus();
          });
    }
    function beforeChange(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider,
        $currentSlide = $slider.find("." + classes.currentSlide),
        $nextSlide = $slider.find(
          '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
        );
      if (isVideoInSlide($currentSlide)) {
        var $currentVideo = $currentSlide.find("." + classes.video),
          currentVideoId = $currentVideo.attr("id");
        theme.SlideshowVideo.pauseVideo(currentVideoId),
          $currentVideo.attr("tabindex", "-1");
      }
      if (isVideoInSlide($nextSlide)) {
        var $video = $nextSlide.find("." + classes.video),
          videoId = $video.attr("id"),
          isBackground = $video.hasClass(classes.videoBackground);
        isBackground
          ? theme.SlideshowVideo.playVideo(videoId)
          : $video.attr("tabindex", "0");
      }
    }
    function isVideoInSlide($slide) {
      return $slide.find("." + classes.video).length;
    }
    slideshow.prototype.togglePause = function () {
      var slideshowSelector = getSlideshowId(this.$pause);
      this.$pause.hasClass(classes.isPaused)
        ? (this.$pause.removeClass(classes.isPaused),
          $(slideshowSelector).slick("slickPlay"))
        : (this.$pause.addClass(classes.isPaused),
          $(slideshowSelector).slick("slickPause"));
    };
    function getSlideshowId($el) {
      return "#Slideshow-" + $el.data("id");
    }
    return slideshow;
  })());
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}
(theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = !1,
    autoplayAvailable = !1,
    playOnClickChecked = !1,
    playOnClick = !1,
    youtubeLoaded = !1,
    videos = {},
    videoPlayers = [],
    videoOptions = {
      ratio: 16 / 9,
      playerVars: {
        iv_load_policy: 3,
        modestbranding: 1,
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        wmode: "opaque",
        branding: 0,
        autohide: 0,
        rel: 0,
      },
      events: { onReady: onPlayerReady, onStateChange: onPlayerChange },
    },
    classes = {
      playing: "video-is-playing",
      paused: "video-is-paused",
      loading: "video-is-loading",
      loaded: "video-is-loaded",
      slideshowWrapper: "slideshow-wrapper",
      slide: "slideshow__slide",
      slideBackgroundVideo: "slideshow__slide--background-video",
      slideDots: "slick-dots",
      videoChrome: "slideshow__video--chrome",
      videoBackground: "slideshow__video--background",
      playVideoBtn: "slideshow__video-control--play",
      closeVideoBtn: "slideshow__video-control--close",
      currentSlide: "slick-current",
      slickClone: "slick-cloned",
      supportsAutoplay: "autoplay",
      supportsNoAutoplay: "no-autoplay",
    };
  function init($video) {
    if (
      $video.length &&
      ((videos[$video.attr("id")] = {
        id: $video.attr("id"),
        videoId: $video.data("id"),
        type: $video.data("type"),
        status: $video.data("type") === "chrome" ? "closed" : "background",
        videoSelector: $video.attr("id"),
        $parentSlide: $video.closest("." + classes.slide),
        $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
        controls: $video.data("type") === "background" ? 0 : 1,
        slideshow: $video.data("slideshow"),
      }),
      !youtubeLoaded)
    ) {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
  function customPlayVideo(playerId) {
    (!playOnClickChecked && !playOnClick) ||
      (playerId &&
        typeof videoPlayers[playerId].playVideo == "function" &&
        privatePlayVideo(playerId));
  }
  function pauseVideo(playerId) {
    videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo == "function" &&
      videoPlayers[playerId].pauseVideo();
  }
  function loadVideos() {
    for (var key in videos)
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        (args.playerVars.controls = args.controls),
          (videoPlayers[key] = new YT.Player(key, args));
      }
    initEvents(), (youtubeLoaded = !0);
  }
  function loadVideo(key) {
    if (youtubeLoaded) {
      var args = $.extend({}, videoOptions, videos[key]);
      (args.playerVars.controls = args.controls),
        (videoPlayers[key] = new YT.Player(key, args)),
        initEvents();
    }
  }
  function privatePlayVideo(id, clicked) {
    var videoData = videos[id],
      player = videoPlayers[id],
      $slide = videos[id].$parentSlide;
    if (playOnClick) setAsPlaying(videoData);
    else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      $slide.removeClass(classes.loading),
        setAsPlaying(videoData),
        player.playVideo();
      return;
    }
    autoplayCheckComplete || autoplayCheckFunction(player, $slide);
  }
  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass),
      supported || (playOnClick = !0),
      (autoplayCheckComplete = !0);
  }
  function autoplayCheckFunction(player, $slide) {
    player.playVideo(),
      autoplayTest(player)
        .then(function () {
          setAutoplaySupport(!0);
        })
        .fail(function () {
          setAutoplaySupport(!1), player.stopVideo();
        })
        .always(function () {
          (autoplayCheckComplete = !0), $slide.removeClass(classes.loading);
        });
  }
  function autoplayTest(player) {
    var deferred = $.Deferred(),
      wait,
      timeout;
    return (
      (wait = setInterval(function () {
        player.getCurrentTime() <= 0 ||
          ((autoplayAvailable = !0),
          clearInterval(wait),
          clearTimeout(timeout),
          deferred.resolve());
      }, 500)),
      (timeout = setTimeout(function () {
        clearInterval(wait), deferred.reject();
      }, 4e3)),
      deferred
    );
  }
  function playOnClickCheck() {
    playOnClickChecked ||
      (($(window).width() < 750 || window.mobileCheck()) && (playOnClick = !0),
      playOnClick && setAutoplaySupport(!1),
      (playOnClickChecked = !0));
  }
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080");
    var videoData = getVideoOptions(evt);
    switch (
      (playOnClickCheck(),
      $("#" + videoData.id).attr("tabindex", "-1"),
      sizeBackgroundVideos(),
      videoData.type)
    ) {
      case "background-chrome":
      case "background":
        evt.target.mute(),
          videoData.$parentSlide.hasClass(classes.currentSlide) &&
            privatePlayVideo(videoData.id);
        break;
    }
    videoData.$parentSlide.addClass(classes.loaded);
  }
  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    switch (evt.data) {
      case 0:
        setAsFinished(videoData);
        break;
      case 1:
        setAsPlaying(videoData);
        break;
      case 2:
        setAsPaused(videoData);
        break;
    }
  }
  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0);
        break;
      case "background-chrome":
        videoPlayers[videoData.id].seekTo(0), closeVideo(videoData.id);
        break;
      case "chrome":
        closeVideo(videoData.id);
        break;
    }
  }
  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper,
      $slide = videoData.$parentSlide;
    if (
      ($slide.removeClass(classes.loading), videoData.status !== "background")
    ) {
      switch (($("#" + videoData.id).attr("tabindex", "0"), videoData.type)) {
        case "chrome":
        case "background-chrome":
          $slideshow.removeClass(classes.paused).addClass(classes.playing),
            $slide.removeClass(classes.paused).addClass(classes.playing);
          break;
      }
      $slide.find("." + classes.closeVideoBtn).focus();
    }
  }
  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper,
      $slide = videoData.$parentSlide;
    if (videoData.type === "background-chrome") {
      closeVideo(videoData.id);
      return;
    }
    videoData.status !== "closed" &&
      videoData.type !== "background" &&
      ($slideshow.addClass(classes.paused), $slide.addClass(classes.paused)),
      videoData.type === "chrome" &&
        videoData.status === "closed" &&
        ($slideshow.removeClass(classes.paused),
        $slide.removeClass(classes.paused)),
      $slideshow.removeClass(classes.playing),
      $slide.removeClass(classes.playing);
  }
  function closeVideo(playerId) {
    var videoData = videos[playerId],
      $slideshow = videoData.$parentSlideshowWrapper,
      $slide = videoData.$parentSlide,
      classesToRemove = [classes.pause, classes.playing].join(" ");
    switch (
      ($("#" + videoData.id).attr("tabindex", "-1"),
      (videoData.status = "closed"),
      videoData.type)
    ) {
      case "background-chrome":
        videoPlayers[playerId].mute(), setBackgroundVideo(playerId);
        break;
      case "chrome":
        videoPlayers[playerId].stopVideo(), setAsPaused(videoData);
        break;
    }
    $slideshow.removeClass(classesToRemove),
      $slide.removeClass(classesToRemove);
  }
  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }
  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    switch (
      (videoData.$parentSlide.addClass(classes.loading),
      (videoData.status = "open"),
      videoData.type)
    ) {
      case "background-chrome":
        unsetBackgroundVideo(playerId, videoData),
          videoPlayers[playerId].unMute(),
          privatePlayVideo(playerId, !0);
        break;
      case "chrome":
        privatePlayVideo(playerId, !0);
        break;
    }
    $(document).on("keydown.videoPlayer", function (evt) {
      evt.keyCode === 27 && closeVideo(playerId);
    });
  }
  function sizeBackgroundVideos() {
    $("." + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }
  function sizeBackgroundVideo($player) {
    var $slide = $player.closest("." + classes.slide);
    if (!$slide.hasClass(classes.slickClone)) {
      var slideWidth = $slide.width(),
        playerWidth = $player.width(),
        playerHeight = $player.height();
      slideWidth / videoOptions.ratio < playerHeight
        ? ((playerWidth = Math.ceil(playerHeight * videoOptions.ratio)),
          $player
            .width(playerWidth)
            .height(playerHeight)
            .css({ left: (slideWidth - playerWidth) / 2, top: 0 }))
        : ((playerHeight = Math.ceil(slideWidth / videoOptions.ratio)),
          $player
            .width(slideWidth)
            .height(playerHeight)
            .css({ left: 0, top: (playerHeight - playerHeight) / 2 })),
        $player.prepareTransition().addClass(classes.loaded);
    }
  }
  function unsetBackgroundVideo(playerId) {
    $("#" + playerId)
      .removeAttr("style")
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome),
      videos[playerId].$parentSlideshowWrapper
        .removeClass(classes.slideBackgroundVideo)
        .addClass(classes.playing),
      videos[playerId].$parentSlide
        .removeClass(classes.slideBackgroundVideo)
        .addClass(classes.playing),
      (videos[playerId].status = "open");
  }
  function setBackgroundVideo(playerId) {
    var $player = $("#" + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);
    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo),
      (videos[playerId].status = "background"),
      sizeBackgroundVideo($player);
  }
  function initEvents() {
    $(document).on(
      "click.videoPlayer",
      "." + classes.playVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data("controls");
        startVideoOnClick(playerId);
      }
    ),
      $(document).on(
        "click.videoPlayer",
        "." + classes.closeVideoBtn,
        function (evt) {
          var playerId = $(evt.currentTarget).data("controls");
          closeVideo(playerId);
        }
      ),
      $(window).on(
        "resize.videoPlayer",
        $.debounce(250, function () {
          youtubeLoaded && sizeBackgroundVideos();
        })
      );
  }
  function removeEvents() {
    $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
  }
  return {
    init,
    loadVideos,
    loadVideo,
    playVideo: customPlayVideo,
    pauseVideo,
    removeEvents,
  };
})()),
  (function () {
    var $filterBy = $("#BlogTagFilter");
    $filterBy.length &&
      $filterBy.on("change", function () {
        location.href = $(this).val();
      });
  })(),
  (window.theme = theme || {}),
  (theme.customerTemplates = (function () {
    function initEventListeners() {
      $("#RecoverPassword").on("click", function (evt) {
        evt.preventDefault(), toggleRecoverPasswordForm();
      }),
        $("#HideRecoverPasswordLink").on("click", function (evt) {
          evt.preventDefault(), toggleRecoverPasswordForm();
        });
    }
    function toggleRecoverPasswordForm() {
      $("#RecoverPasswordForm").toggleClass("hide"),
        $("#CustomerLoginForm").toggleClass("hide");
    }
    function resetPasswordSuccess() {
      var $formState = $(".reset-password-success");
      $formState.length && $("#ResetSuccess").removeClass("hide");
    }
    function customerAddressForm() {
      var $newAddressForm = $("#AddressNewForm");
      $newAddressForm.length &&
        (Shopify &&
          new Shopify.CountryProvinceSelector(
            "AddressCountryNew",
            "AddressProvinceNew",
            { hideElement: "AddressProvinceContainerNew" }
          ),
        $(".address-country-option").each(function () {
          var formId = $(this).data("form-id"),
            countrySelector = "AddressCountry_" + formId,
            provinceSelector = "AddressProvince_" + formId,
            containerSelector = "AddressProvinceContainer_" + formId;
          new Shopify.CountryProvinceSelector(
            countrySelector,
            provinceSelector,
            { hideElement: containerSelector }
          );
        }),
        $(".address-new-toggle").on("click", function () {
          $newAddressForm.toggleClass("hide");
        }),
        $(".address-edit-toggle").on("click", function () {
          var formId = $(this).data("form-id");
          $("#EditAddress_" + formId).toggleClass("hide");
        }),
        $(".address-delete").on("click", function () {
          var $el = $(this),
            formId = $el.data("form-id"),
            confirmMessage = $el.data("confirm-message");
          confirm(
            confirmMessage || "Are you sure you wish to delete this address?"
          ) &&
            Shopify.postLink("/account/addresses/" + formId, {
              parameters: { _method: "delete" },
            });
        }));
    }
    function checkUrlHash() {
      var hash = window.location.hash;
      hash === "#recover" && toggleRecoverPasswordForm();
    }
    return {
      init: function () {
        checkUrlHash(),
          initEventListeners(),
          resetPasswordSuccess(),
          customerAddressForm();
      },
    };
  })()),
  (window.theme = window.theme || {}),
  (theme.Cart = (function () {
    var selectors = { edit: ".js-edit-toggle" },
      config = {
        showClass: "cart__update--show",
        showEditClass: "cart__edit--active",
        cartNoCookies: "cart--no-cookies",
      };
    function Cart(container) {
      (this.$container = $(container)),
        (this.$edit = $(selectors.edit, this.$container)),
        this.cookiesEnabled() || this.$container.addClass(config.cartNoCookies),
        this.$edit.on("click", this._onEditClick.bind(this));
    }
    return (
      (Cart.prototype = _.assignIn({}, Cart.prototype, {
        onUnload: function () {
          this.$edit.off("click", this._onEditClick);
        },
        _onEditClick: function (evt) {
          var $evtTarget = $(evt.target),
            $updateLine = $("." + $evtTarget.data("target"));
          $evtTarget.toggleClass(config.showEditClass),
            $updateLine.toggleClass(config.showClass);
        },
        cookiesEnabled: function () {
          var cookieEnabled = navigator.cookieEnabled;
          return (
            cookieEnabled ||
              ((document.cookie = "testcookie"),
              (cookieEnabled = document.cookie.indexOf("testcookie") !== -1)),
            cookieEnabled
          );
        },
      })),
      Cart
    );
  })()),
  (window.requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (timeOutFn) {
      return setTimeout(timeOutFn, 1e3 / 60);
    }),
  (window.prisma2319 = function () {
    typeof jQuery == "function" &&
    !document.getElementsByClassName("running2319").length &&
    jQuery('[data-section-id="cart-template"]').length &&
    jQuery("#shopify-section-header").length
      ? (document.body.classList.add("running2319"),
        applychanges2319(),
        jQuery(window).on("resize scroll", function () {
          myscroll();
        }),
        console.log("Main Function Running. (running2319)"))
      : document.getElementsByClassName("running2319").length ||
        window.requestAnimationFrame(prisma2319);
  }),
  prisma2319();
function applychanges2319() {
  var smallinter = setInterval(function () {
    !jQuery(".applied").length && jQuery(".section-header").length
      ? (jQuery(
          '<div class="myoffer"><span>Very Limited units left, <br> Checkout before its gone!</span> '
        ).appendTo('[data-section-id="cart-template"] .section-header'),
        jQuery(
          '<div class="mycontinue"><a href="/">Keep Shopping</a></div> '
        ).insertBefore(".cart__footer"),
        jQuery("body").append(
          '<div class="duplicatebutton" onclick="contnue()">Checkout</div>'
        ),
        jQuery("body").addClass("applied"),
        myscroll(),
        clearInterval(smallinter))
      : setTimeout(function () {
          clearInterval(smallinter);
        }, 5e3);
  }, 100);
}
function contnue() {
  jQuery('[name="checkout"]').click();
}
function myscroll() {
  var elementTop =
      jQuery('[name="checkout"]').offset().top -
      jQuery("#shopify-section-header").outerHeight(),
    elementBottom = elementTop + jQuery('[name="checkout"]').outerHeight(),
    viewportTop = jQuery(window).scrollTop(),
    viewportBottom =
      viewportTop +
      jQuery(window).height() -
      jQuery("#shopify-section-header").outerHeight();
  elementBottom > viewportTop && elementTop < viewportBottom
    ? jQuery(".duplicatebutton").fadeOut()
    : jQuery(".duplicatebutton").fadeIn();
}
(window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1e3 / 60);
  }),
  window.location.href == "/cart" && updateChanges_PT_2524_V1(),
  (window.PT_2524_V1 = function () {
    typeof $ < "u" &&
    typeof $.fn.slick < "u" &&
    $("tr.cart__row").length &&
    !document.querySelectorAll(".PT_2524_V1").length
      ? (updateChanges_PT_2524_V1(),
        document.querySelector("body").classList.add("PT_2524_V1"))
      : document.getElementsByClassName("PT_2524_V1").length ||
        window.requestAnimationFrame(PT_2524_V1);
  }),
  window.PT_2524_V1();
function updateChanges_PT_2524_V1() {
  checkIfCartHasMonitors(function () {
    addAreaForArms(),
      handleAddToCart(),
      handleTileClick(),
      console.log("checking");
  });
}
function addAreaForArms() {
  var arms = [
    {
      name: "Arc Stealth",
      img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/3232127ab9bf6fcf50dbf547530e53af_p1.png",
      link: "//prismplus.sg/collections/monitor-arms/products/arc-stealth-single",
      oPrice: "$129",
      sPrice: "$99",
      nsPrice: "$89",
      id: "1558190358551",
      varId: "13216199704599",
    },
    {
      name: "Arc Stealth Dual",
      img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/253a02f8a0ab14f585f83dcf84044db8_2.png",
      link: "//prismplus.sg/collections/monitor-arms/products/arc-stealth-dual",
      oPrice: "$189",
      sPrice: "$149",
      nsPrice: "$139",
      id: "1558199238679",
      varId: "13216221036567",
    },
    {
      name: "Arc Lite",
      img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/6470bac86666d954ea9973ae2547d045_3.png",
      link: "//prismplus.sg/collections/monitor-arms/products/arc-lite",
      oPrice: "$109",
      sPrice: "$69",
      nsPrice: "$59",
      id: "3924399620119",
      varId: "29374581800983",
    },
    {
      name: "Arc Lite Dual",
      img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/b437f1ddce8f09a55f7b650ec3143d05_4.png",
      link: "//prismplus.sg/collections/monitor-arms/products/arc-lite-dual",
      oPrice: "$159",
      sPrice: "$109",
      nsPrice: "$99",
      id: "3924407189527",
      varId: "29374616731671",
    },
    {
      name: "Arc 01",
      img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/90f07f8506ded64a4f37aebef097eebd_5.png",
      link: "//prismplus.sg/collections/monitor-arms/products/arc-01",
      oPrice: "$129",
      sPrice: "$99",
      nsPrice: "$89",
      id: "11576388108",
      varId: "44358737932",
    },
    {
      name: "Arc 02",
      img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/72731d512b2ea508fe55615bf645e42e_6.png",
      link: "//prismplus.sg/collections/monitor-arms/products/arc-02",
      oPrice: "$189",
      sPrice: "$149",
      nsPrice: "$139",
      id: "11576536268",
      varId: "44360091980",
    },
  ];
  if (!$(".vwo_armsWrapper").length && !$(".vwo_armsPopup").length) {
    var armsHtml = "";
    armsHtml +=
      '<div class="vwo_armsWrapper"><h2><strong>55% </strong>has ordered a monitor arm together with a monitor.</h2><div class="slideWrap">';
    for (var i2 = 0; i2 < arms.length; i2++) {
      var name = arms[i2].name,
        img = arms[i2].img,
        link = arms[i2].link,
        oPrice = arms[i2].oPrice,
        nsPrice = arms[i2].sPrice,
        sPrice = arms[i2].nsPrice,
        variant = arms[i2].varId;
      armsHtml +=
        '<div class="slide"><div class="vwo_box" data-category="Monitor Arms" data-title="' +
        name +
        '" data-price="' +
        sPrice.slice(1) +
        '" data-index="' +
        i2 +
        '" data-variant="' +
        variant +
        '"><a href="' +
        link +
        '" class="imgArea"><img src="' +
        img +
        '" /></a><div class="detArea"><a href="' +
        link +
        '"><h3>' +
        name +
        '</h3><div class="v_price"><del class="oPrice">' +
        oPrice +
        '</del><del class="sPrice">' +
        sPrice +
        '</del><span class="nsPrice">' +
        nsPrice +
        '</span></div></a><div class="v_cta"><button class="addtocart_v btn btn--small-wide" type="button"><span>ADD TO CART</span></button></div></div></div></div>';
    }
    (armsHtml += "</div></div>"),
      $("footer.cart__footer").before(armsHtml),
      $(armsHtml)
        .clone()
        .addClass("mobile_v")
        .insertBefore("footer.cart__footer"),
      $(".vwo_armsWrapper.mobile_v > h2").html(
        "<strong>87% </strong>has ordered a monitor arm together with a monitor."
      ),
      initMobileSlider(),
      $("body").removeClass("gettingCart"),
      $(window).resize(function () {
        updateMobileSlider();
      });
    var armsPopupJson = [
        {
          name: "Arc Stealth",
          img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/91dcb1ff77ef69116737a57cf803520a_1.png",
          link: "//prismplus.sg/collections/monitor-arms/products/arc-stealth-single",
          oPrice: "$129",
          sPrice: "$99",
          nsPrice: "$89",
          id: "1558190358551",
          varId: "13216199704599",
          cm: "Aluminum",
          wc: "8Kg",
          ss: "17\u201D - 34\u201D",
        },
        {
          name: "Arc Stealth Dual",
          img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/f47cc1294bb3231ae0c4340916ef034c_2.png",
          link: "//prismplus.sg/collections/monitor-arms/products/arc-stealth-dual",
          oPrice: "$189",
          sPrice: "$149",
          nsPrice: "$139",
          id: "1558199238679",
          varId: "13216221036567",
          cm: "Aluminum",
          wc: "8Kg",
          ss: "17\u201D - 34\u201D",
        },
        {
          name: "Arc Lite",
          img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/0540fcf3e7cda3887bfb60ea4efa7232_3.png",
          link: "//prismplus.sg/collections/monitor-arms/products/arc-lite",
          oPrice: "$109",
          sPrice: "$69",
          nsPrice: "$59",
          id: "3924399620119",
          varId: "29374581800983",
          cm: "Aluminum",
          wc: "6.5Kg",
          ss: "17\u201D - 27\u201D",
        },
        {
          name: "Arc Lite Dual",
          img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/c397d600637791c148a7b20637ff8d11_4.png",
          link: "//prismplus.sg/collections/monitor-arms/products/arc-lite-dual",
          oPrice: "$159",
          sPrice: "$109",
          nsPrice: "$99",
          id: "3924407189527",
          varId: "29374616731671",
          cm: "Aluminum",
          wc: "6.5Kg",
          ss: "17\u201D - 27\u201D",
        },
        {
          name: "Arc 01",
          img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/cc51d17c8a6333491fbc44b3ce7990c6_5.png",
          link: "//prismplus.sg/collections/monitor-arms/products/arc-01",
          oPrice: "$129",
          sPrice: "$99",
          nsPrice: "$89",
          id: "11576388108",
          varId: "44358737932",
          cm: "Aluminum",
          wc: "9Kg",
          ss: "17\u201D - 34\u201D",
        },
        {
          name: "Arc 02",
          img: "//useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/9c84e88ca48d31ea8e7fcf3922faf506_6.png",
          link: "//prismplus.sg/collections/monitor-arms/products/arc-02",
          oPrice: "$189",
          sPrice: "$149",
          nsPrice: "$139",
          id: "11576536268",
          varId: "44360091980",
          cm: "Aluminum",
          wc: "9Kg",
          ss: "17\u201D - 34\u201D",
        },
      ],
      p_armsHtml = "";
    p_armsHtml +=
      '<div class="vwo_armsPopup"><span class="v_overlay" onclick="closePopup()"></span><div class="modalContent"><span class="modalClose" onclick="closePopup()">&times;</span><h2><strong>87% </strong>has ordered a monitor arm together with a monitor.</h2><div class="p_slideWrap">';
    for (var j = 0; j < armsPopupJson.length; j++) {
      var p_name = armsPopupJson[j].name,
        p_img = armsPopupJson[j].img,
        p_link = armsPopupJson[j].link,
        p_oPrice = armsPopupJson[j].oPrice,
        p_nsPrice = armsPopupJson[j].sPrice,
        p_sPrice = armsPopupJson[j].nsPrice,
        p_variant = armsPopupJson[j].varId,
        p_wc = armsPopupJson[j].wc,
        p_cm = armsPopupJson[j].cm,
        p_ss = armsPopupJson[j].ss;
      p_armsHtml +=
        '<div class="slide"><div class="vwo_box" data-variant="' +
        p_variant +
        '"><a href="' +
        p_link +
        '" class="imgArea"><img src="' +
        p_img +
        '" /></a><div class="detArea"><a href="' +
        p_link +
        '"><h3>' +
        p_name +
        '</h3><div class="m_details"><div>Core Material: ' +
        p_cm +
        "</div><div>Weight Capacity: " +
        p_wc +
        "</div><div>Screen Size: " +
        p_ss +
        '</div></div><div class="v_price"><del class="oPrice">' +
        p_oPrice +
        '</del><del class="sPrice">' +
        p_sPrice +
        '</del><span class="nsPrice">' +
        p_nsPrice +
        '</span></div></a><div class="v_cta"><button class="addtocart_v btn btn--small-wide" type="button"><span>ADD TO CART</span></button></div></div></div></div>';
    }
    (p_armsHtml += "</div></div></div>"),
      $("body").prepend(p_armsHtml),
      initMobileSliderPopup();
  }
}
function initMobileSliderPopup() {
  $(".vwo_armsPopup .p_slideWrap").slick({
    dots: !1,
    infinite: !0,
    speed: 300,
    arrows: !0,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
}
function updatePopupSlider() {
  $(".vwo_armsPopup .p_slideWrap").slick("unslick"),
    $(".vwo_armsPopup .p_slideWrap").slick({
      dots: !1,
      infinite: !0,
      speed: 300,
      arrows: !0,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
}
function initMobileSlider() {
  $(".vwo_armsWrapper.mobile_v .slideWrap").slick({
    dots: !0,
    infinite: !0,
    speed: 300,
    arrows: !1,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 361, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });
}
function updateMobileSlider() {
  $(".vwo_armsWrapper.mobile_v .slideWrap").slick("unslick"),
    setTimeout(function () {
      $(".vwo_armsWrapper.mobile_v .slideWrap").slick({
        dots: !0,
        infinite: !0,
        speed: 300,
        arrows: !1,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          { breakpoint: 361, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    }, 100);
}
function handleAddToCart() {
  $(document).on("click", ".addtocart_v", function () {
    if (!$(".adding").length) {
      var THIS = $(this);
      THIS.attr("disabled", "disabled"), THIS.find("span").text("Adding...");
      var box = THIS.parents(".vwo_box"),
        variant = box.attr("data-variant"),
        pri = box.attr("data-price"),
        title = box.attr("data-title"),
        category = box.attr("data-category");
      box.addClass("adding"),
        (pri = pri.replace(/\,/g, "")),
        (pri = parseInt(pri, 10));
      var ttqObj = {
        content_name: title,
        content_category: category,
        content_id: variant,
        content_type: category,
        value: pri,
        quantity: 1,
        currency: "SGD",
      };
      ttq && ttq.track("AddToCart", ttqObj),
        $.ajax({
          url: "/cart/add.js",
          type: "post",
          data: "id=" + variant,
          success: function (res) {
            THIS.removeAttr("disabled"),
              THIS.find("span").text("ADD TO CART"),
              box.removeClass("adding");
          },
          error: function (err) {
            if ((console.log(err), err.responseText.indexOf("quantity") > -1)) {
              var response = JSON.parse(err.responseText);
              self.location.href = "";
            }
          },
        });
    }
  });
}
function handleTileClick() {
  $(document).on("click", ".vwo_armsWrapper .vwo_box a", function (e) {
    e.preventDefault(), $("body").addClass("popupOpened"), updatePopupSlider();
    var slideIndex = $(this).parents(".vwo_box").attr("data-index");
    $(".vwo_armsPopup .p_slideWrap").slick("slickGoTo", slideIndex, !0);
  }),
    $(document).on("click", ".vwo_armsPopup .vwo_box a", function (e) {
      e.preventDefault(),
        $(this)
          .parents(".vwo_box")
          .find("button.addtocart_v:not([disabled])")
          .click();
    });
}
function closePopup() {
  $("body").addClass("closing"),
    setTimeout(function () {
      $("body").removeClass("closing popupOpened");
    }, 500);
}
function checkIfCartHasMonitors(cb) {
  var hasMonitors = !1;
  $.ajax({
    url: "/cart.js",
    type: "get",
    success: function (res) {
      var cartJson = res;
      cartJson.items &&
        cartJson.items.length &&
        (cartJson.items.forEach(function (item) {
          item.product_type &&
            item.product_type == "Monitors" &&
            (hasMonitors = !0);
        }),
        hasMonitors ? cb() : $("body").removeClass("gettingCart"));
    },
    error: function (err) {
      if (err.responseText) {
        var cartJson = JSON.parse(err.responseText);
        cartJson.items &&
          cartJson.items.length &&
          (cartJson.items.forEach(function (item) {
            item.product_type &&
              item.product_type == "Monitors" &&
              (hasMonitors = !0);
          }),
          hasMonitors ? cb() : $("body").removeClass("gettingCart"));
      }
    },
  });
}
(window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1e3 / 60);
  }),
  (window.PT_2595_V1 = function () {
    typeof jQuery < "u" &&
    jQuery(".top_notice_section").length &&
    !document.querySelectorAll(".PT_2595_V1").length
      ? (updateChanges_PT_2595_V1(),
        document.querySelector("body").classList.add("PT_2595_V1"))
      : document.getElementsByClassName("PT_2595_V1").length ||
        window.requestAnimationFrame(PT_2595_V1);
  }),
  window.PT_2595_V1();
function updateChanges_PT_2595_V1() {
  addSalePopup(), handleTopBarClick();
}
function addSalePopup() {
  var popupHtml =
    '<div class="vwo_saleModal"><span class="vwo_overlay" onclick="closeSalePopup()"></span>';
  (popupHtml +=
    '<div class="vwo_modalBody"><span class="vwo_close" onclick="closeSalePopup()">&times;</span>'),
    (popupHtml += '<a href="/collections/tvs">'),
    (popupHtml +=
      '<img class="lazyload vwo_desktop" data-src="https://cdn.shopify.com/s/files/1/1595/6213/files/Campaign-popup-desktop.png?v=1636647183" class="vwo_desktop" />'),
    (popupHtml +=
      '<img class="lazyload vwo_mobile" data-src="https://cdn.shopify.com/s/files/1/1595/6213/files/Campaign-popup-mobile.png?v=1636647183" class="vwo_mobile">'),
    (popupHtml += "</a>"),
    (popupHtml += "</div>"),
    (popupHtml += "</div>"),
    jQuery(".vwo_saleModal").length || jQuery("body").prepend(popupHtml);
}
function handleTopBarClick() {
  jQuery(document).on("click", ".top_notice_section", function () {
    jQuery("body").addClass("vwo_modOpened");
  });
}
function closeSalePopup() {
  jQuery("body").addClass("popupClosing"),
    setTimeout(function () {
      jQuery("body").removeClass("popupClosing"),
        jQuery("body").removeClass("vwo_modOpened");
    }, 400);
}
(window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1e3 / 60);
  }),
  (window.prismPlusTechImage2864V1 = function () {
    if (
      typeof $ < "u" &&
      document.querySelectorAll(".overlay-content .overlay-table").length &&
      !document.getElementsByClassName("prismPlusTechImage2864V1").length
    ) {
      document.body.classList.add("prismPlusTechImage2864V1");
      var meta2 = document.createElement("meta");
      (meta2.name = "viewport"),
        (meta2.content = "width=device-width, initial-scale=1"),
        document.getElementsByTagName("head")[0].appendChild(meta2),
        addTechSpecImages2864V1(),
        updateSpccsLayout2864V1();
    } else window.requestAnimationFrame(prismPlusTechImage2864V1);
  }),
  window.prismPlusTechImage2864V1();
function addTechSpecImages2864V1() {
  var data2 = $(".techimg").text().trim(),
    pathName = location.pathname;
  pathName = pathName.replace("/collections/tvs/products/", "");
  var node = document.querySelectorAll(".overlay-content .overlay-table")[0],
    anchor = document.querySelectorAll(".overlay .closebtn")[0];
  if (
    (node.length > 0 && node.insertBefore(anchor, node.firstChild),
    typeof data2 < "u" &&
      data2 != "" &&
      !document.querySelectorAll(".techSpecsImage").length)
  ) {
    var nodeImage = document.querySelectorAll(".overlay-content")[0],
      div = document.createElement("div");
    div.setAttribute("class", "techSpecsImage lazyload"),
      (div.innerHTML = '<img src="' + data2 + '" alt="" />'),
      nodeImage.insertBefore(div, nodeImage.firstChild);
  }
}
function updateSpccsLayout2864V1() {
  addSpecsWrapper2864V1(),
    divideSpecsIntoTwo2864V1(),
    addMobileSpecClickHandler2864V1(),
    setTechTopPosition2864V1(),
    $(document).click(function () {
      setTimeout(function () {
        var techHeight = $("#mySpec.overlay").height();
        // console.log(techHeight),
          techHeight > 0
            ? $("body").addClass("isTechOpen")
            : $("body").removeClass("isTechOpen");
      }, 500),
        setTechTopPosition2864V1();
    }),
    $(window).resize(function () {
      setTechTopPosition2864V1();
    });
}
function addSpecsWrapper2864V1() {
  if (!$(".vwo_specs").length) {
    var prodName = $("h1.product-single_desktop_title").text();
    $("#mySpec .overlay-table > *").wrapAll('<div class="vwo_specs"></div>'),
      $(".vwo_specs > p").each(function () {
        var specName = $(this)
            .text()
            .trim()
            .toLowerCase()
            .replace(/[^\w\s]/gi, "")
            .replace(/ /g, ""),
          specBlock =
            '<div class="vwo_specBlock ' +
            specName +
            '"><div class="vwo_specTitle"></div><div class="specInfo"></div></div>';
        $(this).before(specBlock),
          $(this)
            .next("table")
            .appendTo($(this).prev(".vwo_specBlock").find(".specInfo")),
          $(this).prependTo(
            $(this).prev(".vwo_specBlock").find(".vwo_specTitle")
          );
      }),
      $("#mySpec > a.closebtn").prependTo(
        "#mySpec .overlay-content .overlay-table"
      ),
      $(".vwo_specs").before("<h2>" + prodName + "</h2>");
  }
}
function divideSpecsIntoTwo2864V1() {
  $(".vwo_blockWrap").length ||
    ($(".vwo_specs").prepend(
      '<div class="blockWrap leftWrap"></div><div class="blockWrap rightWrap"></div>'
    ),
    $(
      ".vwo_specs > .vwo_specBlock:not(.keyspecifications):not(.physicalcharacteristics)"
    ).appendTo(".blockWrap.rightWrap"),
    $(
      ".vwo_specs > .keyspecifications, .vwo_specs > .physicalcharacteristics"
    ).appendTo(".blockWrap.leftWrap"),
    $(".blockWrap.leftWrap > .physicalcharacteristics")
      .clone()
      .insertBefore(".vwo_specBlock.warranty")
      .addClass("vwo_mobileOnly"),
    $(".blockWrap.rightWrap > .physicalcharacteristics.vwo_mobileOnly").hide());
}
function addMobileSpecClickHandler2864V1() {
  $(".vwo_specs .vwo_specTitle").click(function () {
    console.log("test"),
      window.matchMedia("(max-width:767px)").matches &&
        ($(this).parent(".vwo_specBlock").toggleClass("active"));
        /*$(this).parent(".vwo_specBlock.active").length &&
          $("html,body").animate(
            { scrollTop: $(this).offset().top - 10 },
            200
          ));*/
  }),
    $(document).on("click", "button#Specs", function () {
      makeFirstSpecActive2864V12864V1();
    });
}
function makeFirstSpecActive2864V12864V1() {
  $(".vwo_specBlock.active").length == 0 &&
    window.matchMedia("(max-width:767px)").matches &&
    ($("body").addClass("isMobile"),
    $(
      ".blockWrap.leftWrap > .vwo_specBlock:first-child .vwo_specTitle"
    ).click());
}
function setTechTopPosition2864V1() {
  var headerHeight = $("#shopify-section-header").height();
  $("#mySpec.overlay").css({ 'padding-top': headerHeight });
  
}
(window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1e3 / 60);
  }),
  (window.prism2587 = function () {
    typeof jQuery == "function" &&
    !document.getElementsByClassName("running2587").length &&
    jQuery("#shopify-section-list-custom-collections-template").length
      ? (document.body.classList.add("running2587"),
        applychanges2587(),
        console.log("Main Function Running. (running2587)"))
      : document.getElementsByClassName("running2587").length ||
        window.requestAnimationFrame(prism2587);
  }),
  prism2587();
function applychanges2587() {
  var setInter = setInterval(function () {
    if (jQuery("mytab").length)
      setTimeout(function () {
        clearInterval(setInter);
      }, 5e3);
    else {
      var monitors =
          '<h3 class="itemsCategoryHdng itemsCategoryHdng_red">Monitors</h3><div class="grid grid--uniform grid--view-items"><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/gaming-monitors/products/prism-w240"> </a><div class="grid-view-item_3876258250775 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/gaming-monitors/products/prism-w240"> </a><a class="grid-view-item__link" href="/collections/gaming-monitors/products/prism-w240"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/W240-Front_250x250@2x.jpg?v=1594805480" alt="PRISM+ W240"><div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="3876258250775"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.96" data-number-of-reviews="701" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.96" tabindex="0" aria-label="4.96 stars" role="button"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">701 reviews</span></div></div><div class="h4 grid-view-item__title">PRISM+ W240</div><div class="pro_grid_desc descChanged">24" 75Hz IPS Monitor</div><div class="grid-view-item__image"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45}</style><title>Collection Page Stock Status</title> <g id="Blank"> <path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path> <path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2 c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4 c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path> <path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3 c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7 c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6 c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6 c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1 c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path> <path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0 c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3 c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path> <path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0 c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8 c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3 c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3 c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2 c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path> <path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4 c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2 c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path> <path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path> <path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8 c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8 c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path> </g> </svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $229.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$249.00</s></div> </a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/gaming-monitors/products/prism-w240"></a><a href="/collections/gaming-monitors/products/prism-w240">Shop Now</a></div></div><style>.grid-view-item_3876258250775 .grid-view-item__image svg{max-width:115px}.grid-view-item_3876258250775 .grid-view-item__image_info img.grid-view-item__image{max-width:115px}</style></div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/gaming-monitors/products/prism-c270"> </a><div class="grid-view-item_4399702245418 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/gaming-monitors/products/prism-c270"> </a><a class="grid-view-item__link" href="/collections/gaming-monitors/products/prism-c270"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/C270-Front_250x250@2x.jpg?v=1614921258" alt="PRISM+ C270"><div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="4399702245418"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.95" data-number-of-reviews="307" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.95" tabindex="0" aria-label="4.95 stars" role="button"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">307 reviews</span></div></div><div class="h4 grid-view-item__title">PRISM+ C270</div><div class="pro_grid_desc descChanged">27" 75Hz Curved Monitor</div><div class="grid-view-item__image"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45}</style><title>Collection Page Stock Status</title> <g id="Blank"> <path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path> <path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2 c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4 c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path> <path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3 c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7 c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6 c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6 c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1 c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path> <path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0 c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3 c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path> <path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0 c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8 c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3 c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3 c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2 c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path> <path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4 c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2 c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path> <path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path> <path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8 c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8 c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path> </g> </svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $289.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$499.00</s></div> </a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/gaming-monitors/products/prism-c270"></a><a href="/collections/gaming-monitors/products/prism-c270">Shop Now</a></div></div><style>.grid-view-item_4399702245418 .grid-view-item__image svg{max-width:115px}.grid-view-item_4399702245418 .grid-view-item__image_info img.grid-view-item__image{max-width:115px}</style></div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/gaming-monitors/products/prism-x290"> </a><div class="grid-view-item_4391587872810 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/gaming-monitors/products/prism-x290"> </a><a class="grid-view-item__link" href="/collections/gaming-monitors/products/prism-x290"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/X290-Front_250x250@2x.jpg?v=1594804333" alt="PRISM+ X290"><div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="4391587872810"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.97" data-number-of-reviews="369" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.97" tabindex="0" aria-label="4.97 stars" role="button"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">369 reviews</span></div></div><div class="h4 grid-view-item__title">PRISM+ X290</div><div class="pro_grid_desc descChanged">29" 100Hz Ultrawide Curved Gaming Monitor</div><div class="grid-view-item__image"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45}</style><title>Collection Page Stock Status</title> <g id="Blank"> <path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path> <path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2 c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4 c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path> <path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3 c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7 c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6 c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6 c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1 c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path> <path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0 c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3 c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path> <path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0 c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8 c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3 c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3 c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2 c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path> <path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4 c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2 c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path> <path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path> <path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8 c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8 c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path> </g> </svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $349.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$599.00</s></div> </a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/gaming-monitors/products/prism-x290"></a><a href="/collections/gaming-monitors/products/prism-x290">Shop Now</a></div></div><style>.grid-view-item_4391587872810 .grid-view-item__image svg{max-width:115px}.grid-view-item_4391587872810 .grid-view-item__image_info img.grid-view-item__image{max-width:115px}</style></div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/gaming-monitors/products/prism-x340-pro"> </a><div class="grid-view-item_3936445530135 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/gaming-monitors/products/prism-x340-pro"> </a><a class="grid-view-item__link" href="/collections/gaming-monitors/products/prism-x340-pro"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/X340-Front_250x250@2x.jpg?v=1594805414" alt="PRISM+ X340 PRO"><div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="3936445530135"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.95" data-number-of-reviews="662" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.95" tabindex="0" aria-label="4.95 stars" role="button"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">662 reviews</span></div></div><div class="h4 grid-view-item__title">PRISM+ X340 PRO</div><div class="pro_grid_desc descChanged">34" 100Hz Ultrawide Curved Gaming Monitor</div><div class="grid-view-item__image"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45}</style><title>Collection Page Stock Status</title> <g id="Blank"> <path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path> <path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2 c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4 c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path> <path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3 c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7 c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6 c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6 c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1 c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path> <path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0 c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3 c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path> <path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0 c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8 c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3 c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3 c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2 c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path> <path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4 c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2 c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path> <path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path> <path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8 c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8 c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path> </g> </svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $589.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$1,499.00</s></div> </a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/gaming-monitors/products/prism-x340-pro"></a><a href="/collections/gaming-monitors/products/prism-x340-pro">Shop Now</a></div></div><style>.grid-view-item_3936445530135 .grid-view-item__image svg{max-width:115px}.grid-view-item_3936445530135 .grid-view-item__image_info img.grid-view-item__image{max-width:115px}</style></div></div><div class="newbutton"><a href="/collections/gaming-monitors">View All</a></div>',
        monitorArms =
          '<h3 class="itemsCategoryHdng itemsCategoryHdng_red">Monitor Arms</h3><div class="grid grid--uniform grid--view-items"><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/monitor-arms/products/arc-stealth-single"></a><div class="grid-view-item_1558190358551 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/monitor-arms/products/arc-stealth-single"> </a><a class="grid-view-item__link" href="/collections/monitor-arms/products/arc-stealth-single"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/ArcStealthSingle-Front_250x250@2x.jpg?v=1594873849" alt="Arc Stealth"> <div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="1558190358551"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.97" data-number-of-reviews="316" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.97" tabindex="0" aria-label="4.97 stars"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">316 reviews</span> </div></div><div class="h4 grid-view-item__title">Arc Stealth</div><div class="pro_grid_desc"><br>Core Material: Aluminium<br>Weight Capacity: 8kg<br>Screen Size: 17" - 34"</div><div class="grid-view-item__image"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45;}</style><title>Collection Page Stock Status</title><g id="Blank"><path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path><path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path><path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path><path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path><path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path><path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path><path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path><path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path></g></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $99.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$129.00</s> </div></a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/monitor-arms/products/arc-stealth-single"> </a><a href="/collections/monitor-arms/products/arc-stealth-single">Shop Now &gt; </a> </div></div><style>.grid-view-item_1558190358551 .grid-view-item__image svg{max-width:115px;}.grid-view-item_1558190358551 .grid-view-item__image_info img.grid-view-item__image{max-width:115px;}</style> </div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/monitor-arms/products/arc-stealth-dual"></a><div class="grid-view-item_1558199238679 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/monitor-arms/products/arc-stealth-dual"> </a><a class="grid-view-item__link" href="/collections/monitor-arms/products/arc-stealth-dual"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/ArcStealthDual-Front_250x250@2x.jpg?v=1594873875" alt="Arc Stealth Dual"> <div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="1558199238679"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.96" data-number-of-reviews="185" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.96" tabindex="0" aria-label="4.96 stars"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">185 reviews</span> </div></div><div class="h4 grid-view-item__title">Arc Stealth Dual</div><div class="pro_grid_desc"><br>Core Material: Aluminium<br>Weight Capacity: 8kg<br>Screen Size: 17" - 34"</div><div class="grid-view-item__image"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45;}</style><title>Collection Page Stock Status</title><g id="Blank"><path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path><path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path><path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path><path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path><path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path><path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path><path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path><path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path></g></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $149.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$189.00</s> </div></a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/monitor-arms/products/arc-stealth-dual"> </a><a href="/collections/monitor-arms/products/arc-stealth-dual">Shop Now &gt; </a> </div></div><style>.grid-view-item_1558199238679 .grid-view-item__image svg{max-width:115px;}.grid-view-item_1558199238679 .grid-view-item__image_info img.grid-view-item__image{max-width:115px;}</style> </div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/monitor-arms/products/arc-lite"></a><div class="grid-view-item_3924399620119 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/monitor-arms/products/arc-lite"> </a><a class="grid-view-item__link" href="/collections/monitor-arms/products/arc-lite"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/ArcLite-Front_250x250@2x.jpg?v=1594875166" alt="Arc Lite"> <div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="3924399620119"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.94" data-number-of-reviews="193" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.94" tabindex="0" aria-label="4.94 stars"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">193 reviews</span> </div></div><div class="h4 grid-view-item__title">Arc Lite</div><div class="pro_grid_desc"><br>Core Material: Aluminium<br>Weight Capacity: 6.5kg<br>Screen Size: 17" - 27"</div><div class="grid-view-item__image"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45;}</style><title>Collection Page Stock Status</title><g id="Blank"><path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path><path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path><path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path><path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path><path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path><path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path><path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path><path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path></g></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $69.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$109.00</s> </div></a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/monitor-arms/products/arc-lite"> </a><a href="/collections/monitor-arms/products/arc-lite">Shop Now &gt; </a> </div></div><style>.grid-view-item_3924399620119 .grid-view-item__image svg{max-width:115px;}.grid-view-item_3924399620119 .grid-view-item__image_info img.grid-view-item__image{max-width:115px;}</style> </div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/monitor-arms/products/arc-lite-dual"></a><div class="grid-view-item_3924407189527 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/monitor-arms/products/arc-lite-dual"> </a><a class="grid-view-item__link" href="/collections/monitor-arms/products/arc-lite-dual"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/ArcLiteDual-Front_250x250@2x.jpg?v=1594875147" alt="Arc Lite Dual"> <div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="3924407189527"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.91" data-number-of-reviews="46" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.91" tabindex="0" aria-label="4.91 stars"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">46 reviews</span> </div></div><div class="h4 grid-view-item__title">Arc Lite Dual</div><div class="pro_grid_desc"><br>Core Material: Aluminium<br>Weight Capacity: 6.5kg<br>Screen Size: 17" - 27"</div><div class="grid-view-item__image"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45;}</style><title>Collection Page Stock Status</title><g id="Blank"><path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path><path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path><path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path><path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path><path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path><path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path><path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path><path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path></g></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $109.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$159.00</s> </div></a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/monitor-arms/products/arc-lite-dual"> </a><a href="/collections/monitor-arms/products/arc-lite-dual">Shop Now &gt; </a> </div></div><style>.grid-view-item_3924407189527 .grid-view-item__image svg{max-width:115px;}.grid-view-item_3924407189527 .grid-view-item__image_info img.grid-view-item__image{max-width:115px;}</style> </div></div><div class="newbutton"><a href="/collections/monitor-arms">View All</a></div>',
        tvsData =
          '<h3 class="itemsCategoryHdng itemsCategoryHdng_red">TVs</h3><div class="grid grid--uniform grid--view-items"><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/tvs/products/prism-q55-qe-pro"> </a><div class="grid-view-item_6734413758634 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/tvs/products/prism-q55-qe-pro"> </a><a class="grid-view-item__link" href="/collections/tvs/products/prism-q55-qe-pro"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/Q55-QEPRO-Front_250x250@2x.jpg?v=1621847975" alt="PRISM+ Q55-QE PRO"><div style="margin-top: 5px; margin-bottom: -5px; display: none;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="6734413758634"><div style="display:none" class="jdgm-prev-badge" data-average-rating="0.00" data-number-of-reviews="0" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="0.00" tabindex="0" aria-label="0.00 stars" role="button"> <span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span> </span> <span class="jdgm-prev-badge__text">No reviews</span></div></div><div class="h4 grid-view-item__title">PRISM+ Q55-QE PRO</div><div class="pro_grid_desc">55" Best Value 4K Android TV\u2122</div><div class="grid-view-item__image"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 24"><title>Collection Page Stock Status</title></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $999.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$1,999.00</s></div> </a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/tvs/products/prism-q55-qe-pro"></a><a href="/collections/tvs/products/prism-q55-qe-pro">Shop Now</a></div></div><style>.grid-view-item_6734413758634 .grid-view-item__image svg{max-width:115px}.grid-view-item_6734413758634 .grid-view-item__image_info img.grid-view-item__image{max-width:115px}</style></div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/tvs/products/prism-q65-qe-pro"> </a><div class="grid-view-item_6734416314538 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/tvs/products/prism-q65-qe-pro"> </a><a class="grid-view-item__link" href="/collections/tvs/products/prism-q65-qe-pro"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/Q65-QEPRO-Front_250x250@2x.jpg?v=1621847990" alt="PRISM+ Q65-QE PRO"><div style="margin-top: 5px; margin-bottom: -5px; display: none;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="6734416314538"><div style="display:none" class="jdgm-prev-badge" data-average-rating="0.00" data-number-of-reviews="0" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="0.00" tabindex="0" aria-label="0.00 stars" role="button"> <span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span> </span> <span class="jdgm-prev-badge__text">No reviews</span></div></div><div class="h4 grid-view-item__title">PRISM+ Q65-QE PRO</div><div class="pro_grid_desc">65" Best Value 4K Android TV\u2122</div><div class="grid-view-item__image"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 24"><title>Collection Page Stock Status</title></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $1,199.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$2,999.00</s></div> </a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/tvs/products/prism-q65-qe-pro"></a><a href="/collections/tvs/products/prism-q65-qe-pro">Shop Now</a></div></div><style>.grid-view-item_6734416314538 .grid-view-item__image svg{max-width:115px}.grid-view-item_6734416314538 .grid-view-item__image_info img.grid-view-item__image{max-width:115px}</style></div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/tvs/products/prism-q86-qe-pro"> </a><div class="grid-view-item_6618038403242 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/tvs/products/prism-q86-qe-pro"> </a><a class="grid-view-item__link" href="/collections/tvs/products/prism-q86-qe-pro"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/Q86-QEPRO-Front_250x250@2x.jpg?v=1621848006" alt="PRISM+ Q86-QE PRO"><div style="margin-top: 5px; margin-bottom: -5px; display: none;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="6618038403242"><div style="display:none" class="jdgm-prev-badge" data-average-rating="0.00" data-number-of-reviews="0" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="0.00" tabindex="0" aria-label="0.00 stars" role="button"> <span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span><span class="jdgm-star jdgm--off"></span> </span> <span class="jdgm-prev-badge__text">No reviews</span></div></div><div class="h4 grid-view-item__title">PRISM+ Q86-QE PRO</div><div class="pro_grid_desc">86" Best Value 4K Android TV\u2122</div><div class="grid-view-item__image"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 24"><title>Collection Page Stock Status</title></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $3,199.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$6,999.00</s></div> </a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/tvs/products/prism-q86-qe-pro"></a><a href="/collections/tvs/products/prism-q86-qe-pro">Shop Now</a></div></div><style>.grid-view-item_6618038403242 .grid-view-item__image svg{max-width:115px}.grid-view-item_6618038403242 .grid-view-item__image_info img.grid-view-item__image{max-width:115px}</style></div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/tvs/products/prism-q55"> </a><div class="grid-view-item_4567592599594 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/tvs/products/prism-q55"> </a><a class="grid-view-item__link" href="/collections/tvs/products/prism-q55"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/Q55-QE-Front_30dc851e-6a00-4821-9745-fa0c4e6ada89_250x250@2x.jpg?v=1608739349" alt="PRISM+ Q55-QE"><div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="4567592599594"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.92" data-number-of-reviews="1041" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.92" tabindex="0" aria-label="4.92 stars" role="button"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">1041 reviews</span></div></div><div class="h4 grid-view-item__title">PRISM+ Q55-QE</div><div class="pro_grid_desc">55" Best Value 4K Android TV\u2122</div><div class="grid-view-item__image"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45}</style><title>Collection Page Stock Status</title> <g id="Blank"> <path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path> <path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2 c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4 c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path> <path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3 c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7 c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6 c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6 c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1 c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path> <path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0 c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3 c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path> <path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0 c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8 c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3 c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3 c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2 c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path> <path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4 c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2 c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path> <path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path> <path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8 c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8 c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path> </g> </svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $799.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$1,199.00</s></div> </a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/tvs/products/prism-q55"></a><a href="/collections/tvs/products/prism-q55">Shop Now</a></div></div><style>.grid-view-item_4567592599594 .grid-view-item__image svg{max-width:115px}.grid-view-item_4567592599594 .grid-view-item__image_info img.grid-view-item__image{max-width:115px}</style></div></div><div class="newbutton"><a href="/collections/tvs">View All</a></div>',
        tvStands =
          '<h3 class="itemsCategoryHdng itemsCategoryHdng_red">TV Stands</h3><div class="grid grid--uniform grid--view-items"> <div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/tv-stands/products/kanva-tripod-tv-stand"></a><div class="grid-view-item_4340519960618 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/tv-stands/products/kanva-tripod-tv-stand"> </a><a class="grid-view-item__link" href="/collections/tv-stands/products/kanva-tripod-tv-stand"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/KanvaTripodBlack-Front_250x250@2x.jpg?v=1594877097" alt="Kanva Tripod TV Stand"> <div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="4340519960618"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.98" data-number-of-reviews="43" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.98" tabindex="0" aria-label="4.98 stars"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">43 reviews</span> </div></div><div class="h4 grid-view-item__title">Kanva Tripod TV Stand</div><div class="pro_grid_desc"><br>Core Material: Aluminium, Beech<br>Weight Capacity: 32kg<br>Screen Size: 43" - 65"</div><div class="grid-view-item__image"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45;}</style><title>Collection Page Stock Status</title><g id="Blank"><path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path><path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path><path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path><path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path><path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path><path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path><path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path><path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path></g></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $169.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$369.00</s> </div></a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/tv-stands/products/kanva-tripod-tv-stand"> </a><a href="/collections/tv-stands/products/kanva-tripod-tv-stand">Shop Now &gt; </a> </div></div><style>.grid-view-item_4340519960618 .grid-view-item__image svg{max-width:115px;}.grid-view-item_4340519960618 .grid-view-item__image_info img.grid-view-item__image{max-width:115px;}</style> </div><div class="grid__item grid__item--collection-template small--one-half medium-up--one-quarter"> <a class="grid-view-item_outer_link" href="/collections/tv-stands/products/kanva-quad-tv-stand"></a><div class="grid-view-item_4340522614826 info_logo_true grid-view-item"><a class="grid-view-item_outer_link" href="/collections/tv-stands/products/kanva-quad-tv-stand"> </a><a class="grid-view-item__link" href="/collections/tv-stands/products/kanva-quad-tv-stand"> <img class="grid-view-item__image" src="//cdn.shopify.com/s/files/1/1595/6213/products/KanvaQuadBlack-Front_250x250@2x.jpg?v=1594877166" alt="Kanva Quad TV Stand"> <div style="margin-top: 5px; margin-bottom: -5px;" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="4340522614826"><div style="display:none" class="jdgm-prev-badge" data-average-rating="4.91" data-number-of-reviews="22" data-number-of-questions="0"> <span class="jdgm-prev-badge__stars" data-score="4.91" tabindex="0" aria-label="4.91 stars"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-prev-badge__text">22 reviews</span> </div></div><div class="h4 grid-view-item__title">Kanva Quad TV Stand</div><div class="pro_grid_desc"><br>Core Material: Aluminium, Beech<br>Weight Capacity: 40kg<br>Screen Size: 43" - 70"</div><div class="grid-view-item__image"> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58.2 14" style="enable-background:new 0 0 58.2 14;" xml:space="preserve"><style type="text/css">.st0{fill:#29AA45;}</style><title>Collection Page Stock Status</title><g id="Blank"><path class="st0" d="M15.6,3.4h1.3v7.4h-1.3V3.4z"></path><path class="st0" d="M18.4,5.7h1.2v0.8l0,0c0.1-0.2,0.3-0.5,0.5-0.6c0.3-0.2,0.6-0.3,1-0.3c0.3,0,0.6,0,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.3,0.6C23,7.1,23,7.3,23,7.6v3.2h-1.2V8.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.1c-0.2,0-0.4,0-0.5,0.1C20.2,6.9,20.1,7,20,7.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2-0.1,0.3-0.1,0.5v2.7h-1.2L18.4,5.7z"></path><path class="st0" d="M31.3,4.9c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.3,0.6,0.3c0.3,0.1,0.5,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.6c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.8-0.4-1.1-0.8l1-1c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.1,0.5,0.2,0.8,0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.6c-0.2-0.3-0.3-0.7-0.3-1c0-0.3,0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.7-0.1,1-0.1c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6L31.3,4.9z"></path><path class="st0" d="M33,6.8V5.7h1V4.3h1.2v1.5h1.4v1.1h-1.4V9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.6,0.2c0.1,0,0.2,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1v1.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6C34,9.7,34,9.4,34,9.1V6.8L33,6.8z"></path><path class="st0" d="M37.4,8.3c0-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.5c0.7-0.2,1.4-0.2,2.1,0c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.5,0.4-0.9,0.5c-0.7,0.2-1.4,0.2-2.1,0c-0.7-0.2-1.2-0.7-1.4-1.4C37.5,9,37.4,8.6,37.4,8.3z M38.6,8.3c0,0.2,0,0.4,0.1,0.6C38.8,9,38.9,9.2,39,9.3c0.1,0.1,0.3,0.3,0.5,0.3c0.4,0.2,0.8,0.2,1.2,0c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0.1-0.8,0-1.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-1.1-0.6-1.7-0.3C39.3,7,39.2,7.1,39,7.2c-0.1,0.1-0.2,0.3-0.3,0.5C38.7,7.9,38.6,8.1,38.6,8.3L38.6,8.3z"></path><path class="st0" d="M47.5,7.2C47.3,7.1,47.2,7,47,6.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.6,0-1.2,0.4-1.4,0.9c-0.1,0.4-0.1,0.8,0,1.1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.3,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3l0.8,0.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-1,0.3c-0.1,0-0.3,0-0.4,0c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.2-0.7-1.4-1.4c-0.3-0.7-0.3-1.5,0-2.2c0.1-0.3,0.3-0.6,0.6-0.8c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.6L47.5,7.2z"></path><path class="st0" d="M49.1,2.8h1.2v5l1.9-2.1h1.6L51.7,8l2.3,2.7h-1.7l-2-2.6l0,0v2.6h-1.2L49.1,2.8z"></path><path class="st0" d="M4.1,7.7c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.4-0.7,0.6-0.9C5.2,5.4,5.5,5.2,5.8,5C6.2,4.9,6.6,4.8,7,4.8c0.4,0,0.8,0.1,1.1,0.2c0.7,0.3,1.2,0.9,1.5,1.5c0.2,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1C9.5,9.2,9.3,9.5,9,9.8c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.4,0-0.8-0.1-1.1-0.2c-0.7-0.3-1.2-0.9-1.5-1.5C4.1,8.5,4.1,8.1,4.1,7.7z"></path></g></svg></div><div class="grid-view-item__meta"> <span class="product-price__price product-price__sale"> $199.00 <span class="product-price__sale-label">Sale</span> </span> <span class="visually-hidden">Regular price</span> <s class="product-price__price">$469.00</s> </div></a><div class="grid_shop"><a class="grid-view-item__link" href="/collections/tv-stands/products/kanva-quad-tv-stand"> </a><a href="/collections/tv-stands/products/kanva-quad-tv-stand">Shop Now &gt; </a> </div></div><style>.grid-view-item_4340522614826 .grid-view-item__image svg{max-width:115px;}.grid-view-item_4340522614826 .grid-view-item__image_info img.grid-view-item__image{max-width:115px;}</style> </div></div><div class="newbutton"><a href="/collections/tv-stands">View All</a></div>',
        tabs = '<div class="tab-container mytab">';
      (tabs += '<ul class="myul">'),
        (tabs += '<li data-rel="monitors">Monitors</li>'),
        (tabs += '<li data-rel="smartTVS">Smart TVs</li>'),
        (tabs += '<li data-rel="monitorArms">Monitor Arms</li>'),
        (tabs += '<li data-rel="TVStands">TV Stands</li>'),
        (tabs += "</ul></div>");
      var tabsData = '<div class="tabDataContainer">';
      (tabsData +=
        '<div id="monitors" class="tabcontent">' + monitors + "</div>"),
        (tabsData +=
          '<div id="monitorArms" class="tabcontent">' + monitorArms + "</div>"),
        (tabsData +=
          '<div id="smartTVS" class="tabcontent">' + tvsData + "</div>"),
        (tabsData +=
          '<div id="TVStands" class="tabcontent">' + tvStands + "</div>"),
        (tabsData += "</div>"),
        jQuery(
          "#shopify-section-list-custom-collections-template > .page-width"
        ).before(tabs),
        jQuery(".grid_custom_list").after(tabsData),
        jQuery(".myul li").on("click", function () {
          var clicked = jQuery(this).attr("data-rel");
          jQuery(".myul li").removeClass("selected"),
            jQuery(this).addClass("selected"),
            jQuery(".tabcontent").hide(),
            jQuery(".tabcontent#" + clicked).show();
        }),
        jQuery(".myul li").eq(0).click(),
        clearInterval(setInter);
    }
  }, 10);
}
(window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1e3 / 60);
  }),
  (window.ppCategorPages2901V1 = function () {
    if (
      document.querySelectorAll(".tabcontent .grid_shop a").length &&
      !document.getElementsByClassName("ppCategorPages2901V1").length
    ) {
      document.body.classList.add("ppCategorPages2901V1");
      var meta2 = document.createElement("meta");
      (meta2.name = "viewport"),
        (meta2.content = "width=device-width, initial-scale=1"),
        document.getElementsByTagName("head")[0].appendChild(meta2),
        changeShopNowBtnText2901V1();
    } else window.requestAnimationFrame(ppCategorPages2901V1);
  }),
  window.ppCategorPages2901V1();
function changeShopNowBtnText2901V1() {
  var elem = document.querySelectorAll(".tabcontent .grid_shop a");
  for (i = 0; i < elem.length; i++) {
    var txt = elem[i].innerHTML;
    (txt = txt
      .replace("Shop Now >", "Shop Now")
      .replace("Shop Now &gt;", "Shop Now")),
      (txt = txt.trim()),
      (elem[i].innerHTML = txt);
  }
}
(window.theme = window.theme || {}),
  (theme.Filters = (function () {
    var constants = { SORT_BY: "sort_by" },
      selectors = {
        filterSelection: ".filters-toolbar__input--filter",
        sortSelection: ".filters-toolbar__input--sort",
        defaultSort: ".collection-header__default-sort",
      };
    function Filters(container) {
      var $container = (this.$container = $(container));
      (this.$filterSelect = $(selectors.filterSelection, $container)),
        (this.$sortSelect = $(selectors.sortSelection, $container)),
        (this.$selects = $(selectors.filterSelection, $container).add(
          $(selectors.sortSelection, $container)
        )),
        (this.defaultSort = this._getDefaultSortValue()),
        this._resizeSelect(this.$selects),
        this.$selects.removeClass("hidden"),
        this.$filterSelect.on("change", this._onFilterChange.bind(this)),
        this.$sortSelect.on("change", this._onSortChange.bind(this));
    }
    return (
      (Filters.prototype = _.assignIn({}, Filters.prototype, {
        _onSortChange: function (evt) {
          var sort = this._sortValue();
          sort.length
            ? (window.location.search = sort)
            : (window.location.href = window.location.href.replace(
                window.location.search,
                ""
              )),
            this._resizeSelect($(evt.target));
        },
        _onFilterChange: function (evt) {
          (window.location.href =
            this.$filterSelect.val() + window.location.search),
            this._resizeSelect($(evt.target));
        },
        _getSortValue: function () {
          return this.$sortSelect.val() || this.defaultSort;
        },
        _getDefaultSortValue: function () {
          return $(selectors.defaultSort, this.$container).val();
        },
        _sortValue: function () {
          var sort = this._getSortValue(),
            query = "";
          return (
            sort !== this.defaultSort &&
              (query = constants.SORT_BY + "=" + sort),
            query
          );
        },
        _resizeSelect: function ($selection) {
          $selection.each(function () {
            var $this = $(this),
              arrowWidth = 10,
              text = $this.find("option:selected").text(),
              $test = $("<span>").html(text);
            $test.appendTo("body");
            var width = $test.width();
            $test.remove(), $this.width(width + arrowWidth);
          });
        },
        onUnload: function () {
          this.$filterSelect.off("change", this._onFilterChange),
            this.$sortSelect.off("change", this._onSortChange);
        },
      })),
      Filters
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.HeaderSection = (function () {
    function Header() {
      theme.Header.init(), theme.MobileNav.init(), theme.Search.init();
    }
    return (
      (Header.prototype = _.assignIn({}, Header.prototype, {
        onUnload: function () {
          theme.Header.unload();
        },
      })),
      Header
    );
  })()),
  (theme.Maps = (function () {
    var config = { zoom: 14 },
      apiStatus = null,
      mapsToLoad = [],
      key = theme.mapKey ? theme.mapKey : "";
    function Map(container) {
      (this.$container = $(container)),
        apiStatus === "loaded"
          ? this.createMap()
          : (mapsToLoad.push(this),
            apiStatus !== "loading" &&
              ((apiStatus = "loading"),
              typeof window.google > "u" &&
                $.getScript(
                  "https://maps.googleapis.com/maps/api/js?key=" + key
                ).then(function () {
                  (apiStatus = "loaded"), initAllMaps();
                })));
    }
    function initAllMaps() {
      $.each(mapsToLoad, function (index, instance) {
        instance.createMap();
      });
    }
    function geolocate($map) {
      var deferred = $.Deferred(),
        geocoder = new google.maps.Geocoder(),
        address = $map.data("address-setting");
      return (
        geocoder.geocode({ address }, function (results, status2) {
          status2 !== google.maps.GeocoderStatus.OK && deferred.reject(status2),
            deferred.resolve(results);
        }),
        deferred
      );
    }
    return (
      (Map.prototype = _.assignIn({}, Map.prototype, {
        createMap: function () {
          var $map = this.$container.find(".map-section__container");
          return geolocate($map)
            .then(
              function (results) {
                var mapOptions = {
                    zoom: config.zoom,
                    center: results[0].geometry.location,
                    disableDefaultUI: !0,
                  },
                  map = (this.map = new google.maps.Map($map[0], mapOptions)),
                  center = (this.center = map.getCenter()),
                  marker = new google.maps.Marker({
                    map,
                    position: map.getCenter(),
                  });
                google.maps.event.addDomListener(
                  window,
                  "resize",
                  $.debounce(250, function () {
                    google.maps.event.trigger(map, "resize"),
                      map.setCenter(center);
                  })
                );
              }.bind(this)
            )
            .fail(function () {
              var errorMessage;
              switch (status) {
                case "ZERO_RESULTS":
                  errorMessage = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  errorMessage = theme.strings.addressQueryLimit;
                  break;
                default:
                  errorMessage = theme.strings.addressError;
                  break;
              }
              $map
                .parent()
                .addClass("page-width map-section--load-error")
                .html(
                  '<div class="errors text-center">' + errorMessage + "</div>"
                );
            });
        },
        onUnload: function () {
          google.maps.event.clearListeners(this.map, "resize");
        },
      })),
      Map
    );
  })());
function gm_authFailure() {
  $(".map-section").addClass("map-section--load-error"),
    $(".map-section__container").remove(),
    $(".map-section__link").remove(),
    $(".map-section__overlay").after(
      '<div class="errors text-center">' + theme.strings.authError + "</div>"
    );
}
(theme.Product = (function () {
  function Product(container) {
    var $container = (this.$container = $(container)),
      sectionId = $container.attr("data-section-id");
    (this.settings = {
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      mediaQuerySmall: "screen and (max-width: 749px)",
      bpSmall: !1,
      enableHistoryState: $container.data("enable-history-state") || !1,
      imageSize: null,
      imageZoomSize: null,
      namespace: ".slideshow-" + sectionId,
      sectionId,
      sliderActive: !1,
      zoomEnabled: !1,
    }),
      (this.selectors = {
        addToCart: "#AddToCart-" + sectionId,
        addToCartText: "#AddToCartText-" + sectionId,
        comparePrice: "#ComparePrice-" + sectionId,
        originalPrice: "#ProductPrice-" + sectionId,
        SKU: ".variant-sku",
        originalPriceWrapper: ".product-price__price-" + sectionId,
        originalSelectorId: "#ProductSelect-" + sectionId,
        productFeaturedImage: "#FeaturedImage-" + sectionId,
        productImageWrap: "#FeaturedImageZoom-" + sectionId,
        productPrices: ".product-single__price-" + sectionId,
        productThumbImages: ".product-single__thumbnail--" + sectionId,
        productThumbs: ".product-single__thumbnails-" + sectionId,
        saleClasses: "product-price__sale product-price__sale--single",
        saleLabel: ".product-price__sale-label-" + sectionId,
        singleOptionSelector: ".single-option-selector-" + sectionId,
      }),
      $("#ProductJson-" + sectionId).html() &&
        ((this.productSingleObject = JSON.parse(
          document.getElementById("ProductJson-" + sectionId).innerHTML
        )),
        (this.settings.zoomEnabled = $(
          this.selectors.productFeaturedImage
        ).hasClass("js-zoom-enabled")),
        (this.settings.imageSize = theme.Images.imageSize(
          $(this.selectors.productFeaturedImage).attr("src")
        )),
        this.settings.zoomEnabled &&
          (this.settings.imageZoomSize = theme.Images.imageSize(
            $(this.selectors.productImageWrap).data("zoom")
          )),
        this._initBreakpoints(),
        this._stringOverrides(),
        this._initVariants(),
        this._initImageSwitch(),
        this._setActiveThumbnail());
  }
  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      (theme.productStrings = theme.productStrings || {}),
        $.extend(theme.strings, theme.productStrings);
    },
    _initBreakpoints: function () {
      var self2 = this;
      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          $(self2.selectors.productThumbImages).length > 3 &&
            self2._initThumbnailSlider(),
            self2.settings.zoomEnabled &&
              _destroyZoom($(self2.selectors.productImageWrap)),
            (self2.settings.bpSmall = !0);
        },
        unmatch: function () {
          self2.settings.sliderActive && self2._destroyThumbnailSlider(),
            (self2.settings.bpSmall = !1);
        },
      }),
        enquire.register(this.settings.mediaQueryMediumUp, {
          match: function () {
            self2.settings.zoomEnabled &&
              _enableZoom($(self2.selectors.productImageWrap));
          },
        });
    },
    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data("enable-history-state") || !1,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };
      (this.variants = new slate.Variants(options)),
        this.$container.on(
          "variantChange" + this.settings.namespace,
          this._updateAddToCart.bind(this)
        ),
        this.$container.on(
          "variantImageChange" + this.settings.namespace,
          this._updateImages.bind(this)
        ),
        this.$container.on(
          "variantPriceChange" + this.settings.namespace,
          this._updatePrice.bind(this)
        ),
        this.$container.on(
          "variantSKUChange" + this.settings.namespace,
          this._updateSKU.bind(this)
        );
    },
    _initImageSwitch: function () {
      if ($(this.selectors.productThumbImages).length) {
        var self2 = this;
        $(this.selectors.productThumbImages).on("click", function (evt) {
          evt.preventDefault();
          var $el = $(this),
            imageSrc = $el.attr("href"),
            zoomSrc = $el.data("zoom");
          self2._switchImage(imageSrc, zoomSrc),
            self2._setActiveThumbnail(imageSrc);
        });
      }
    },
    _setActiveThumbnail: function (src2) {
      var activeClass = "active-thumb";
      typeof src2 > "u" &&
        (src2 = $(this.selectors.productFeaturedImage).attr("src"));
      var $thumbnail = $(
        this.selectors.productThumbImages + '[href="' + src2 + '"]'
      );
      $(this.selectors.productThumbImages).removeClass(activeClass),
        $thumbnail.addClass(activeClass);
    },
    _switchImage: function (image, zoomImage) {
      $(this.selectors.productFeaturedImage).attr("src", image),
        this.settings.zoomEnabled &&
          _destroyZoom($(this.selectors.productImageWrap)),
        !this.settings.bpSmall &&
          this.settings.zoomEnabled &&
          zoomImage &&
          ($(this.selectors.productImageWrap).data("zoom", zoomImage),
          _enableZoom($(this.selectors.productImageWrap)));
    },
    _initThumbnailSlider: function () {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: !1,
        prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
        nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
        responsive: [{ breakpoint: 321, settings: { slidesToShow: 3 } }],
      };
      $(this.selectors.productThumbs).slick(options),
        (this.settings.sliderActive = !0);
    },
    _destroyThumbnailSlider: function () {
      $(this.selectors.productThumbs).slick("unslick"),
        (this.settings.sliderActive = !1);
    },
    _updateAddToCart: function (evt) {
      var variant = evt.variant;
      variant
        ? ($(this.selectors.productPrices)
            .removeClass("visibility-hidden")
            .attr("aria-hidden", "true"),
          variant.available
            ? ($(this.selectors.addToCart).prop("disabled", !1),
              $(this.selectors.addToCartText).text(theme.strings.addToCart))
            : ($(this.selectors.addToCart).prop("disabled", !0),
              $(this.selectors.addToCartText).text(theme.strings.soldOut)))
        : ($(this.selectors.addToCart).prop("disabled", !0),
          $(this.selectors.addToCartText).text(theme.strings.unavailable),
          $(this.selectors.productPrices)
            .addClass("visibility-hidden")
            .attr("aria-hidden", "false"));
    },
    _updateImages: function (evt) {
      var variant = evt.variant,
        sizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_image.src,
          this.settings.imageSize
        ),
        zoomSizedImgUrl;
      this.settings.zoomEnabled &&
        (zoomSizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_image.src,
          this.settings.imageZoomSize
        )),
        this._switchImage(sizedImgUrl, zoomSizedImgUrl),
        this._setActiveThumbnail(sizedImgUrl);
    },
    _updatePrice: function (evt) {
      var variant = evt.variant;
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      ),
        variant.compare_at_price > variant.price
          ? ($(this.selectors.comparePrice)
              .html(
                theme.Currency.formatMoney(
                  variant.compare_at_price,
                  theme.moneyFormat
                )
              )
              .removeClass("hide"),
            $(this.selectors.originalPriceWrapper).addClass(
              this.selectors.saleClasses
            ),
            $(this.selectors.saleLabel).removeClass("hide"))
          : ($(this.selectors.comparePrice).addClass("hide"),
            $(this.selectors.saleLabel).addClass("hide"),
            $(this.selectors.originalPriceWrapper).removeClass(
              this.selectors.saleClasses
            ));
    },
    _updateSKU: function (evt) {
      var variant = evt.variant;
      $(this.selectors.SKU).html(variant.sku);
    },
    onUnload: function () {
      this.$container.off(this.settings.namespace);
    },
  });
  function _enableZoom($el) {
    var zoomUrl = $el.data("zoom");
    $el.zoom({ url: zoomUrl });
  }
  function _destroyZoom($el) {
    $el.trigger("zoom.destroy");
  }
  return Product;
})()),
  (theme.Quotes = (function () {
    var config = {
        mediaQuerySmall: "screen and (max-width: 749px)",
        mediaQueryMediumUp: "screen and (min-width: 750px)",
        slideCount: 0,
      },
      defaults = {
        accessibility: !0,
        arrows: !1,
        dots: !0,
        autoplay: !1,
        touchThreshold: 20,
        slidesToShow: 3,
        slidesToScroll: 3,
      };
    function Quotes(container) {
      var $container = (this.$container = $(container)),
        sectionId = $container.attr("data-section-id"),
        wrapper = (this.wrapper = ".quotes-wrapper"),
        slider = (this.slider = "#Quotes-" + sectionId),
        $slider = $(slider, wrapper),
        sliderActive = !1,
        mobileOptions = $.extend({}, defaults, {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: !0,
        });
      (config.slideCount = $slider.data("count")),
        config.slideCount < defaults.slidesToShow &&
          ((defaults.slidesToShow = config.slideCount),
          (defaults.slidesToScroll = config.slideCount)),
        $slider.on("init", this.a11y.bind(this)),
        enquire.register(config.mediaQuerySmall, {
          match: function () {
            initSlider($slider, mobileOptions);
          },
        }),
        enquire.register(config.mediaQueryMediumUp, {
          match: function () {
            initSlider($slider, defaults);
          },
        });
      function initSlider(sliderObj, args) {
        sliderActive && (sliderObj.slick("unslick"), (sliderActive = !1)),
          sliderObj.slick(args),
          (sliderActive = !0);
      }
    }
    return (
      (Quotes.prototype = _.assignIn({}, Quotes.prototype, {
        onUnload: function () {
          enquire.unregister(config.mediaQuerySmall),
            enquire.unregister(config.mediaQueryMediumUp),
            $(this.slider, this.wrapper).slick("unslick");
        },
        onBlockSelect: function (evt) {
          var $slide = $(
              ".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)"
            ),
            slideIndex = $slide.data("slick-index");
          $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
        },
        a11y: function (event, obj) {
          var $list = obj.$list,
            $wrapper = $(this.wrapper, this.$container);
          $list.removeAttr("aria-live"),
            $wrapper.on("focusin", function (evt) {
              $wrapper.has(evt.target).length &&
                $list.attr("aria-live", "polite");
            }),
            $wrapper.on("focusout", function (evt) {
              $wrapper.has(evt.target).length && $list.removeAttr("aria-live");
            });
        },
      })),
      Quotes
    );
  })()),
  (theme.slideshows = {}),
  (theme.SlideshowSection = (function () {
    function SlideshowSection(container) {
      var $container = (this.$container = $(container)),
        sectionId = $container.attr("data-section-id"),
        slideshow = (this.slideshow = "#Slideshow-" + sectionId);
      $(".slideshow__video", slideshow).each(function () {
        var $el = $(this);
        theme.SlideshowVideo.init($el),
          theme.SlideshowVideo.loadVideo($el.attr("id"));
      }),
        (theme.slideshows[slideshow] = new theme.Slideshow(slideshow));
    }
    return SlideshowSection;
  })()),
  (theme.SlideshowSection.prototype = _.assignIn(
    {},
    theme.SlideshowSection.prototype,
    {
      onUnload: function () {
        delete theme.slideshows[this.slideshow];
      },
      onBlockSelect: function (evt) {
        var $slideshow = $(this.slideshow),
          $slide = $(
            ".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"
          ),
          slideIndex = $slide.data("slick-index");
        $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
      },
      onBlockDeselect: function () {
        $(this.slideshow).slick("slickPlay");
      },
    }
  )),
  $(document).ready(function () {
    var sections = new theme.Sections();
    sections.register("cart-template", theme.Cart),
      sections.register("product", theme.Product),
      sections.register("collection-template", theme.Filters),
      sections.register("product-template", theme.Product),
      sections.register("header-section", theme.HeaderSection),
      sections.register("map", theme.Maps),
      sections.register("slideshow-section", theme.SlideshowSection),
      sections.register("quotes", theme.Quotes);
    var get_timer_date = $("#top_notice_ends").attr("data_timer_date"),
      newDate = new Date(get_timer_date).getTime(),
      countDownDate = new Date(get_timer_date).getTime(),
      x = setInterval(function () {
        var now = new Date().getTime(),
          distance = countDownDate - now,
          days = Math.floor(distance / (1e3 * 60 * 60 * 24)),
          hours = Math.floor(
            (distance % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60)
          ),
          minutes = Math.floor((distance % (1e3 * 60 * 60)) / (1e3 * 60)),
          seconds = Math.floor((distance % (1e3 * 60)) / 1e3);
        if (distance < 0)
          clearInterval(x),
            (document.getElementById("top_notice_ends").innerHTML = " "),
            (document.getElementById("top_notice_ends").innerHTML = " ");
        else {
          var test =
            "<b>" +
            days +
            "<span>d</span></b><b> " +
            hours +
            "<span>h</span></b><b> " +
            minutes +
            "<span>m</span></b><b> " +
            seconds +
            "<span>s</span></b>";
          jQuery("#top_notice_timer").html(test);
        }
      }, 1e3);
    $(".popup-gallery a").magnificPopup({
      type: "image",
      closeBtnInside: !1,
      mainClass: "mfp-with-zoom mfp-img-mobile",
      image: {
        verticalFit: !0,
        titleSrc: function (item) {
          var caption = item.el.attr("title"),
            pinItURL = "https://pinterest.com/pin/create/button/";
          return (
            (pinItURL += "?url=/"),
            (pinItURL += "&media=" + item.el.attr("href")),
            (pinItURL += "&description=" + caption),
            caption +
              ' &middot; <a class="pin-it" href="' +
              pinItURL +
              '" target="_blank"><img src="https://assets.pinterest.com/images/pidgets/pin_it_button.png" /></a>'
          );
        },
      },
      gallery: { enabled: !0 },
      callbacks: {
        open: function () {
          this.wrap.on("click.pinhandler", ".pin-it", function (e) {});
        },
        beforeClose: function () {},
      },
    });
    var validateEmail = function (elementValue) {
      var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailPattern.test(elementValue);
    };
    if (
      ($("body").on(
        "click",
        ".contact_form_info_wrapper #mc-embedded-subscribe",
        function () {
          var value = $(".contact_form_info_wrapper #mce-EMAIL").val(),
            valid = validateEmail(value);
          valid
            ? setTimeout(function () {
                var get_form_result = $(
                  ".contact_form_info_wrapper #mce-responses"
                ).text();
                get_form_result.indexOf("Thank you for enquiry!") > -1 &&
                  $(".klaviyo-thanks-btn").trigger("click");
              }, 2e3)
            : $(this).css("border-color", "red");
        }
      ),
      $(window).on("load", function () {
        setTimeout(function () {
          var text_myvar =
            '<textarea class="get_message_klavi" rows="4" cols="50">';
          $('.klaviyo-form input[aria-label="MESSAGE"]').before(text_myvar),
            $("body").on("change", ".get_message_klavi", function () {
              $('.klaviyo-form input[aria-label="MESSAGE"]').val($(this).val());
            });
        }, 3e3);
      }),
      $(function () {
        $(".template-product").length,
          $("[data-popup-open]").on("click", function (e) {
            var targeted_popup_class = jQuery(this).attr("data-popup-open");
            $('[data-popup="' + targeted_popup_class + '"]').fadeIn(350),
              $("body").addClass("active-corporate-popup"),
              e.preventDefault();
          }),
          $("[data-popup-close]").on("click", function (e) {
            var targeted_popup_class = jQuery(this).attr("data-popup-close");
            $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350),
              $("body").removeClass("active-corporate-popup"),
              e.preventDefault();
          });
      }),
      $(function () {
        $("[data-popup-open-dyn]").on("click", function (e) {
          var targeted_popup_class = jQuery(this).attr("data-popup-open-dyn"),
            get_inner_data = jQuery(this).find(".popup_inner_data").html();
          $('[data-popup-dyn="' + targeted_popup_class + '"]')
            .find(".popup_data_content")
            .empty(),
            $('[data-popup-dyn="' + targeted_popup_class + '"]')
              .find(".popup_data_content")
              .append(get_inner_data),
            $('[data-popup-dyn="' + targeted_popup_class + '"]').fadeIn(350),
            $("html").addClass("tech_popup_is_open"),
            e.preventDefault();
        }),
          $("[data-popup-close-dyn]").on("click", function (e) {
            var targeted_popup_class = jQuery(this).attr(
              "data-popup-close-dyn"
            );
            $('[data-popup-dyn="' + targeted_popup_class + '"]').fadeOut(350),
              $("html").removeClass("tech_popup_is_open"),
              $('[data-popup-dyn="' + targeted_popup_class + '"]')
                .find(".popup_data_content")
                .empty(),
              e.preventDefault();
          });
      }),
      $("#contact_form_primary .option-button").on("click", function (e) {
        var get_data_send_cat = $(this).attr("data-send-category"),
          get_cat = $(this).attr("data-category"),
          get_cat_val = $(this).attr("data-value"),
          get_cat_icon = $(this).find(".cat_icon").html();
        $("#contact_form_primary").slideUp(),
          $("#contact_form_category_wrapper").slideDown(),
          $("#contact_form_secondary").slideDown(),
          get_data_send_cat == "normal"
            ? ($("select[name='q6_inquiryType']")
                .val(get_cat_val)
                .trigger("change"),
              $(".zendesk_form_center_section").show(),
              $(".marketing_form_section").hide())
            : get_data_send_cat == "normal-tag"
            ? ($("select[name='q6_inquiryType']")
                .val(get_cat_val)
                .trigger("change"),
              $(".jotform-zendesk-form select[name='q9_productType']")
                .val("")
                .trigger("change"),
              $(".jotform-zendesk-form select[name='q8_zendeskTag']")
                .val(get_cat)
                .trigger("change"),
              $(".zendesk_form_center_section").show(),
              $(".marketing_form_section").hide(),
              $("#contact_form_secondary").hide(),
              $(".feature-row__item.contact_form_wrapper").slideDown(),
              $(".contact_form_main_filed_section").addClass(
                "active_left_panel_block"
              ))
            : get_data_send_cat == "direct" &&
              ($(".jotform-marketing-form select[name='q6_inquiryType']")
                .val(get_cat_val)
                .trigger("change"),
              $(".zendesk_form_center_section").hide(),
              $(".marketing_form_section").show(),
              $("#contact_form_secondary").hide(),
              $(".feature-row__item.contact_form_wrapper").slideDown(),
              $(".contact_form_main_filed_section").addClass(
                "active_left_panel_block"
              )),
          $(".info_image_inner").hide(),
          get_cat == "RMA"
            ? ($(".jotform-zendesk-form .orderNumber_block").show(),
              $(".jotform-zendesk-form .serialNumber_block").show(),
              $(".jotform-zendesk-form .form_control_fileupload").show())
            : get_cat == "Leadtime" || get_cat == "Delay" || get_cat == "CR"
            ? ($(".jotform-zendesk-form .orderNumber_block").show(),
              $(".jotform-zendesk-form .serialNumber_block").hide(),
              $(".jotform-zendesk-form .form_control_fileupload").hide())
            : ($(".jotform-zendesk-form .orderNumber_block").hide(),
              $(".jotform-zendesk-form .serialNumber_block").hide(),
              $(".jotform-zendesk-form .form_control_fileupload").hide()),
          $("#contact_form_secondary_options .option-button").each(function () {
            $(this).attr("data-category", get_cat);
          }),
          $(
            "#contact_form_category_wrapper #contact_form_category_primary"
          ).text(get_cat_val),
          $(
            "#contact_form_category_wrapper #contact_form_category_primary"
          ).prepend(get_cat_icon);
      }),
      $("#contact_form_category_wrapper .option-change").on(
        "click",
        function (e) {
          $("#contact_form_primary").slideDown(),
            $("#contact_form_category_wrapper").slideUp(),
            $("#contact_form_secondary").slideUp(),
            $(".feature-row__item.contact_form_wrapper").hide(),
            $(".contact_form_main_filed_section").removeClass(
              "active_left_panel_block"
            ),
            $(".CaptchaTxtField_section").show(),
            CreateCaptcha(),
            CreateCaptcha_zendesk2();
        }
      ),
      $("#contact_form_secondary_options .option-button").on(
        "click",
        function (e) {
          var get_cat_product_type = $(this).attr("data-value"),
            get_cat_product_type_tag = $(this).attr("data-tag-value"),
            get_cat_type = $(this).attr("data-category"),
            get_cat_product_tags =
              get_cat_type + "-" + get_cat_product_type_tag;
          $("select[name='q9_productType']")
            .val(get_cat_product_type)
            .trigger("change"),
            $("select[name='q8_zendeskTag']")
              .val(get_cat_product_tags)
              .trigger("change"),
            get_cat_type == "RMA"
              ? ($(".jotform-zendesk-form .form_control_fileupload").show(),
                get_cat_product_type == "Monitor" ||
                get_cat_product_type == "TV"
                  ? ($(".jotform-zendesk-form .orderNumber_block").show(),
                    $(".jotform-zendesk-form .serialNumber_block").show(),
                    $(".jotform-zendesk-form .orderNumber_block")
                      .find(".form-textbox")
                      .prop("required", !0),
                    $(".jotform-zendesk-form .serialNumber_block")
                      .find(".form-textbox")
                      .prop("required", !0),
                    get_cat_product_type == "Monitor"
                      ? ($(".info_image_inner_monitor").show(),
                        $(".info_image_inner_tv").hide())
                      : get_cat_product_type == "TV" &&
                        ($(".info_image_inner_monitor").hide(),
                        $(".info_image_inner_tv").show()))
                  : ($(".jotform-zendesk-form .orderNumber_block").show(),
                    $(".jotform-zendesk-form .serialNumber_block").hide(),
                    $(".jotform-zendesk-form .orderNumber_block")
                      .find(".form-textbox")
                      .prop("required", !0),
                    $(".jotform-zendesk-form .serialNumber_block")
                      .find(".form-textbox")
                      .prop("required", !1),
                    $(".info_image_inner").hide()))
              : get_cat_type == "Leadtime" ||
                get_cat_type == "Delay" ||
                get_cat_type == "CR"
              ? ($(".jotform-zendesk-form .form_control_fileupload").hide(),
                $(".jotform-zendesk-form .orderNumber_block").show(),
                $(".jotform-zendesk-form .serialNumber_block").hide(),
                $(".jotform-zendesk-form .orderNumber_block")
                  .find(".form-textbox")
                  .prop("required", !0),
                $(".jotform-zendesk-form .serialNumber_block")
                  .find(".form-textbox")
                  .prop("required", !1))
              : ($(".jotform-zendesk-form .form_control_fileupload").hide(),
                $(".jotform-zendesk-form .orderNumber_block").hide(),
                $(".jotform-zendesk-form .serialNumber_block").hide(),
                $(".jotform-zendesk-form .orderNumber_block")
                  .find(".form-textbox")
                  .prop("required", !1),
                $(".jotform-zendesk-form .serialNumber_block")
                  .find(".form-textbox")
                  .prop("required", !1),
                $(".info_image_inner").hide()),
            $("#contact_form_secondary").hide(),
            $(".feature-row__item.contact_form_wrapper").slideDown(),
            $(".contact_form_main_filed_section").addClass(
              "active_left_panel_block"
            );
        }
      ),
      $(".CaptchaTxtField_section").length)
    ) {
      let CreateCaptcha2 = function () {
          var alpha = new Array(
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "I",
              "J",
              "K",
              "L",
              "M",
              "N",
              "O",
              "P",
              "Q",
              "R",
              "S",
              "T",
              "U",
              "V",
              "W",
              "X",
              "Y",
              "Z",
              "a",
              "b",
              "c",
              "d",
              "e",
              "f",
              "g",
              "h",
              "i",
              "j",
              "k",
              "l",
              "m",
              "n",
              "o",
              "p",
              "q",
              "r",
              "s",
              "t",
              "u",
              "v",
              "w",
              "x",
              "y",
              "z",
              "0",
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9"
            ),
            i2;
          for (i2 = 0; i2 < 6; i2++)
            var a = alpha[Math.floor(Math.random() * alpha.length)],
              b = alpha[Math.floor(Math.random() * alpha.length)],
              c = alpha[Math.floor(Math.random() * alpha.length)],
              d = alpha[Math.floor(Math.random() * alpha.length)],
              e = alpha[Math.floor(Math.random() * alpha.length)],
              f = alpha[Math.floor(Math.random() * alpha.length)];
          (cd = a + " " + b + " " + c + " " + d + " " + e + " " + f),
            $("#CaptchaImageCode")
              .empty()
              .append(
                '<canvas id="CapCode" class="capcode" width="250" height="80"></canvas>'
              );
          var c = document.getElementById("CapCode"),
            ctx = c.getContext("2d"),
            x2 = c.width / 2,
            img = new Image();
          (img.src =
            "https://pixelsharing.files.wordpress.com/2010/11/salvage-tileable-and-seamless-pattern.jpg"),
            (img.onload = function () {
              var pattern = ctx.createPattern(img, "repeat");
              (ctx.fillStyle = pattern),
                ctx.fillRect(0, 0, c.width, c.height),
                (ctx.font = "35px Roboto Slab"),
                (ctx.fillStyle = "#ccc"),
                (ctx.textAlign = "center"),
                ctx.setTransform(1, -0.12, 0, 1, 0, 15),
                ctx.fillText(cd, x2, 55);
            }),
            $("#CaptchaImageCode")
              .closest("form")
              .addClass("captch_active_form");
        },
        CreateCaptcha_zendesk22 = function () {
          var alpha = new Array(
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "I",
              "J",
              "K",
              "L",
              "M",
              "N",
              "O",
              "P",
              "Q",
              "R",
              "S",
              "T",
              "U",
              "V",
              "W",
              "X",
              "Y",
              "Z",
              "a",
              "b",
              "c",
              "d",
              "e",
              "f",
              "g",
              "h",
              "i",
              "j",
              "k",
              "l",
              "m",
              "n",
              "o",
              "p",
              "q",
              "r",
              "s",
              "t",
              "u",
              "v",
              "w",
              "x",
              "y",
              "z",
              "0",
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9"
            ),
            i2;
          for (i2 = 0; i2 < 6; i2++)
            var a = alpha[Math.floor(Math.random() * alpha.length)],
              b = alpha[Math.floor(Math.random() * alpha.length)],
              c = alpha[Math.floor(Math.random() * alpha.length)],
              d = alpha[Math.floor(Math.random() * alpha.length)],
              e = alpha[Math.floor(Math.random() * alpha.length)],
              f = alpha[Math.floor(Math.random() * alpha.length)];
          (cd2 = a + " " + b + " " + c + " " + d + " " + e + " " + f),
            $("#CaptchaImageCode_zendesk2")
              .empty()
              .append(
                '<canvas id="CapCode_zendesk2" class="capcode" width="250" height="80"></canvas>'
              );
          var c = document.getElementById("CapCode_zendesk2"),
            ctx = c.getContext("2d"),
            x2 = c.width / 2,
            img = new Image();
          (img.src =
            "https://pixelsharing.files.wordpress.com/2010/11/salvage-tileable-and-seamless-pattern.jpg"),
            (img.onload = function () {
              var pattern = ctx.createPattern(img, "repeat");
              (ctx.fillStyle = pattern),
                ctx.fillRect(0, 0, c.width, c.height),
                (ctx.font = "35px Roboto Slab"),
                (ctx.fillStyle = "#ccc"),
                (ctx.textAlign = "center"),
                ctx.setTransform(1, -0.12, 0, 1, 0, 15),
                ctx.fillText(cd2, x2, 55);
            }),
            $("#CaptchaImageCode_zendesk2")
              .closest("form")
              .addClass("captch_active_form");
        },
        ValidateCaptcha2 = function () {
          var string1 = removeSpaces2(cd),
            string2 = removeSpaces2($("#UserCaptchaCode").val());
          return string1 == string2;
        },
        ValidateCaptcha_zendesk22 = function () {
          var string1 = removeSpaces2(cd2),
            string2 = removeSpaces2($("#UserCaptchaCode_zendesk2").val());
          return string1 == string2;
        },
        removeSpaces2 = function (string) {
          return string.split(" ").join("");
        },
        CheckCaptcha2 = function () {
          var result = ValidateCaptcha2();
          $("#UserCaptchaCode").val() == "" ||
          $("#UserCaptchaCode").val() == null ||
          $("#UserCaptchaCode").val() == "undefined"
            ? ($("#WrongCaptchaError")
                .text("Please enter code given below in a picture.")
                .show(),
              $("#UserCaptchaCode").focus())
            : result == !1
            ? ($("#WrongCaptchaError")
                .text("Invalid Captcha! Please try again.")
                .show(),
              CreateCaptcha2(),
              $("#UserCaptchaCode").focus().select())
            : ($("#UserCaptchaCode")
                .val("")
                .attr("place-holder", "Enter Captcha - Case Sensitive"),
              CreateCaptcha2(),
              $("#WrongCaptchaError").fadeOut(100),
              $("#SuccessMessage")
                .fadeIn(500)
                .css("display", "block")
                .delay(5e3)
                .fadeOut(250));
        };
      var CreateCaptcha = CreateCaptcha2,
        CreateCaptcha_zendesk2 = CreateCaptcha_zendesk22,
        ValidateCaptcha = ValidateCaptcha2,
        ValidateCaptcha_zendesk2 = ValidateCaptcha_zendesk22,
        removeSpaces = removeSpaces2,
        CheckCaptcha = CheckCaptcha2,
        cd,
        cd2;
      $(function () {
        CreateCaptcha2(), CreateCaptcha_zendesk22();
      }),
        $(".CaptchaTxtField_section .ReloadBtn_zendesk1").on(
          "click",
          function (e) {
            CreateCaptcha2();
          }
        ),
        $(".CaptchaTxtField_section .ReloadBtn_zendesk2").on(
          "click",
          function (e) {
            CreateCaptcha_zendesk22();
          }
        ),
        $("body").on(
          "change keyup",
          ".CaptchaTxtField_section.CaptchaTxtField_section_zendesk1 #UserCaptchaCode",
          function () {
            var result = ValidateCaptcha2();
            $("#UserCaptchaCode").val() == "" ||
            $("#UserCaptchaCode").val() == null ||
            $("#UserCaptchaCode").val() == "undefined"
              ? ($("#WrongCaptchaError")
                  .text("Please enter code given below in a picture.")
                  .show(),
                $("#UserCaptchaCode").focus())
              : result == !1
              ? $("#WrongCaptchaError")
                  .text("Invalid Captcha! Please try again.")
                  .show()
              : ($("#UserCaptchaCode")
                  .val("")
                  .attr("place-holder", "Enter Captcha - Case Sensitive"),
                $("#WrongCaptchaError").fadeOut(100),
                $("#SuccessMessage")
                  .fadeIn(500)
                  .css("display", "block")
                  .delay(5e3)
                  .fadeOut(250),
                $("#CaptchaImageCode")
                  .closest("form")
                  .removeClass("captch_active_form"),
                $(".CaptchaTxtField_section_zendesk1")
                  .fadeIn(500)
                  .css("display", "block")
                  .delay(10)
                  .fadeOut(250));
          }
        ),
        $("body").on(
          "change keyup",
          ".CaptchaTxtField_section.CaptchaTxtField_section_zendesk2 #UserCaptchaCode_zendesk2",
          function () {
            var result = ValidateCaptcha_zendesk22();
            $("#UserCaptchaCode_zendesk2").val() == "" ||
            $("#UserCaptchaCode_zendesk2").val() == null ||
            $("#UserCaptchaCode_zendesk2").val() == "undefined"
              ? ($("#WrongCaptchaError_zendesk2")
                  .text("Please enter code given below in a picture.")
                  .show(),
                $("#UserCaptchaCode_zendesk2").focus())
              : result == !1
              ? $("#WrongCaptchaError_zendesk2")
                  .text("Invalid Captcha! Please try again.")
                  .show()
              : ($("#UserCaptchaCode_zendesk2")
                  .val("")
                  .attr("place-holder", "Enter Captcha - Case Sensitive"),
                $("#WrongCaptchaError_zendesk2").fadeOut(100),
                $("#SuccessMessage_zendesk2")
                  .fadeIn(500)
                  .css("display", "block")
                  .delay(5e3)
                  .fadeOut(250),
                $("#CaptchaImageCode_zendesk2")
                  .closest("form")
                  .removeClass("captch_active_form"),
                $(".CaptchaTxtField_section_zendesk2")
                  .fadeIn(500)
                  .css("display", "block")
                  .delay(10)
                  .fadeOut(250));
          }
        );
    }
    $('a[href*="#"]')
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          if (target.hasClass("pdp-popup")) return;
          (target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]")),
            target.length &&
              (event.preventDefault(),
              $("html, body").animate(
                { scrollTop: target.offset().top - 120 },
                1e3,
                function () {
                  var $target = $(target);
                  if (($target.focus(), $target.is(":focus"))) return !1;
                  $target.attr("tabindex", "-1"), $target.focus();
                }
              ));
        }
      }),
      jQuery("#carousel").owlCarousel({
        autoplay: !0,
        lazyLoad: !0,
        loop: !0,
        margin: 20,
        dots: !1,
        responsiveClass: !0,
        autoHeight: !0,
        autoplayTimeout: 7e3,
        smartSpeed: 800,
        nav: !0,
        responsive: {
          0: { items: 1 },
          600: { items: 3 },
          1024: { items: 4 },
          1366: { items: 4 },
        },
      }),
      $(".featured-customer-photos-index1 .owl-carousel").owlCarousel({
        loop: !0,
        margin: 11,
        nav: !0,
        navText: [
          "<i class='fa fa-caret-left'></i>",
          "<i class='fa fa-caret-right'></i>",
        ],
        autoplay: !0,
        autoplayHoverPause: !0,
        responsive: {
          0: { items: 1, center: !0, stagePadding: 30, nav: !1 },
          600: { items: 3 },
          1e3: { items: 4 },
        },
      }),
      $(".logo_mobile_slider_section .owl-carousel").owlCarousel({
        loop: !0,
        margin: 11,
        nav: !1,
        navText: [
          '<svg enable-background="new 0 0 477.175 477.175" version="1.1" viewBox="0 0 477.18 477.18" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m145.19 238.58 215.5-215.5c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-225.1 225.1c-5.3 5.3-5.3 13.8 0 19.1l225.1 225c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-215.4-215.5z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.175 477.175"><path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"/></svg>',
        ],
        autoplay: !0,
        autoplayHoverPause: !0,
        responsive: {
          0: { items: 1, nav: !1 },
          600: { items: 3 },
          1e3: { items: 4 },
        },
      }),
      $(window).resize(function () {
        $(".logo_mobile_slider_section .owl-carousel").trigger(
          "refresh.owl.carousel"
        );
      }),
      $(".template-product .carousel-wrap .owl-carousel").owlCarousel({
        loop: !0,
        margin: 11,
        dots: !1,
        responsiveClass: !0,
        autoHeight: !0,
        nav: !0,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;" xml:space="preserve"><g transform="matrix(-1 -1.22465e-16 1.22465e-16 -1 451.846 451.847)"><g><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744   L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284   c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z" data-original="#000000" class="active-path" fill="#000000"/></g></g> </svg>',
          '<svg enable-background="new 0 0 451.846 451.847" version="1.1" viewBox="0 0 451.85 451.85" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m345.44 248.29-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z"/></svg>',
        ],
        autoplay: !1,
        autoplayHoverPause: !0,
        responsive: {
          0: { items: 1, nav: !0 },
          600: { items: 1 },
          1e3: { items: 1 },
        },
      }),
      $(".pmi_custom-slider-image-section .owl-carousel").owlCarousel({
        loop: !0,
        margin: 11,
        nav: !0,
        dots: !1,
        navText: [
          "<i class='fa fa-caret-left'></i>",
          "<i class='fa fa-caret-right'></i>",
        ],
        autoplay: !0,
        autoplayHoverPause: !0,
        responsive: {
          0: { items: 1, center: !0, stagePadding: 30, dots: !0, nav: !1 },
          600: { items: 3 },
          1e3: { items: 6, nav: !0 },
        },
      }),
      $(".career_job-container .content-entry").click(function (event) {
        var get_job_title = $(this).find(".article-title").html(),
          get_job_desc = $(this).find(".accordion-content").html();
        $(".career_job-container .content-entry")
          .find(".accordion-content")
          .slideUp(),
          $(this).find(".accordion-content").css("display") == "none"
            ? $(this).find(".accordion-content").slideToggle()
            : $(this).find(".accordion-content").slideUp(),
          $(".career_job_desc-container").hide(),
          $(".career_job_desc-container").slideDown(),
          $(".career_job_desc-container")
            .find(".article-title")
            .html(get_job_title),
          $(".career_job_desc-container")
            .find(".accordion-content")
            .html(get_job_desc),
          event.stopPropagation();
      });
    var my_svg_icon_q =
      '<svg class="svg-inline--fa fa-question-circle fa-w-16" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="question-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"></path></svg>';
    $("i.question-circle").replaceWith(""),
      $("span.question-circle").replaceWith(""),
      $(".b_list_status_block .buttom_note .toolpopup").prepend(my_svg_icon_q);
  }),
  (theme.init = function () {
    theme.customerTemplates.init(),
      slate.rte.wrapTable(),
      slate.rte.iframeReset(),
      slate.a11y.pageLinkFocus($(window.location.hash)),
      $(".in-page-link").on("click", function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
      }),
      $('a[href="#"]').on("click", function (evt) {
        evt.preventDefault();
      });
  }),
  $(theme.init),
  (lazySizesConfig.loadHidden = !1),
  (lazySizesConfig.loadMode = 1),
  (lazySizesConfig.expand = 100),
  (lazySizesConfig.expFactor = 1.2),
  setTimeout(function () {
    lazySizesConfig.preloadAfterLoad = !0;
  }, 1e4);
let cookieName = "trigger=true",
  isCookieSet = document.cookie.split(";").includes(cookieName);
function checkCookie(isCookieSet2) {
  isCookieSet2
    ? insertThirdParty("cookie exist")
    : (window.addEventListener("scroll", () => insertThirdParty("scroll"), {
        once: !0,
      }),
      document.addEventListener("click", () => insertThirdParty("click"), {
        once: !0,
      }),
      document.addEventListener(
        "touchstart",
        () => insertThirdParty("touchstart"),
        { once: !0 }
      ),
      document.addEventListener(
        "mousemove",
        () => insertThirdParty("mousemove"),
        { once: !0 }
      ));
}
function insertThirdParty(event) {
  (insertThirdParty = function () {}),
    document.removeEventListener(
      "mouseover",
      () => insertThirdParty("mouseover"),
      { once: !0 }
    ),
    document.removeEventListener("scroll", () => insertThirdParty("scroll"), {
      once: !0,
    }),
    document.removeEventListener(
      "touchstart",
      () => insertThirdParty("touchstart"),
      { once: !0 }
    ),
    document.removeEventListener(
      "mousemove",
      () => insertThirdParty("mousemove"),
      { once: !0 }
    );
  var arrScripts = document.querySelectorAll(
    'script[type="text/lazyloadscript"]'
  );
  arrScripts.forEach(function (s) {
    if (s.src && !s.src.includes("undefined")) {
      let script = document.createElement("script");
      (script.src = s.src),
        (script.async = !0),
        document.body.appendChild(script);
    }
  }),
    (document.cookie = cookieName);
}
checkCookie(isCookieSet),
  (window.requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (timeOutFn) {
      return setTimeout(timeOutFn, 1e3 / 60);
    }),
  (window.requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (timeOutFn) {
      return setTimeout(timeOutFn, 1e3 / 60);
    }),
  (window.prismNavReorder3392V2 = function () {
    typeof jQuery < "u" &&
    jQuery("#shopify-section-header header").length &&
    !jQuery(".prismNavReorder3392V2").length
      ? (jQuery("body").addClass("prismNavReorder3392V2"),
        jQuery("head").prepend(
          '<meta name="viewport" content="width=device-width, initial-scale=1">'
        ),
        reorderTopNavigation3392V2())
      : window.requestAnimationFrame(prismNavReorder3392V2);
  }),
  window.prismNavReorder3392V2();
function reorderTopNavigation3392V2() {
  jQuery(
    "#shopify-section-header header #SiteNav .header-wrap .mobile-nav-wrapper li:contains(TVs)"
  )
    .prependTo("#shopify-section-header header #SiteNav")
    .find("a")
    .html("Android TVs"),
    jQuery(
      "#shopify-section-header header #SiteNav .header-wrap .mobile-nav-wrapper li:contains(Monitor Stands)"
    ).remove();
}
if (jQuery("body.template-product").length)
  var initPDP = setTimeout(function () {
    if (typeof meta == "object") {
      var currRecentData = [];
      localStorage.getItem("recentItemsList") &&
        localStorage.getItem("recentItemsList") != "" &&
        (currRecentData = JSON.parse(localStorage.getItem("recentItemsList")));
      var productID = meta.product.id,
        alreadyAdded = !1;
      jQuery.each(currRecentData, function (a, b) {
        b.itemID == productID && (alreadyAdded = !0);
      }),
        alreadyAdded ||
          (currRecentData.length >= 3 && currRecentData.splice(0, 1),
          currRecentData.push({
            itemID: productID,
            link: window.location.href,
            img: jQuery(".product-featured-img").attr("data-src"),
            title: jQuery(
              ".product-single__meta h1.product-single_desktop_title .main"
            )
              .text()
              .trim(),
            alttitle: jQuery(".prod-alt-title").text().trim(),
            desc: jQuery(".prod-short-desc").text().trim(),
            MRP: jQuery("#ProductPrice-product-template")
              .text()
              .replace("SGD", "")
              .trim(),
            MRP2: jQuery("#zero-lowestprice").text().replace("SGD", "").trim(),
            voucher: jQuery(".voucher-pricing .voucher-wrap span#voucher-price")
              .text()
              .replace("SGD", "")
              .trim(),
            SP: jQuery("#ComparePrice-product-template")
              .text()
              .replace("SGD", "")
              .trim(),
            FLASH: jQuery(".pdpFlashSaleBnrWrap").html(),
          }),
          localStorage.setItem(
            "recentItemsList",
            JSON.stringify(currRecentData)
          )),
        clearInterval(initPDP);
    }
  }, 250);
jQuery(document).ready(function ($2) {
  $2(window).width() < 1023
    ? $2(".stock-wrap-nov2 .learnmore").click(function () {
        $2(".stock-wrap-nov2 .popover").addClass("show"),
          $2(".stockclose").addClass("show");
      })
    : $2(".stock-wrap-nov2 .learnmore").hover(function () {
        $2(".stock-wrap-nov2 .popover").toggleClass("show");
      }),
    $2(".stockclose").click(function () {
      $2(".stock-wrap-nov2 .popover").removeClass("show"),
        $2(".stockclose").removeClass("show");
    });
}),
  jQuery(document).ready(function () {
    $("#cart-initiateCheckout").click(function () {
      fbq("track", "InitiateCheckout");
      var ttqArr = [];
      $(".fbcart-row-count").each(function (index) {
        var pri = $(this).attr("data-product-price"),
          pri = pri.replace(/\,/g, "");
        pri = parseInt(pri, 10);
        var ttqObj = {
          content_name: $(this).attr("data-product-title"),
          content_id: $(this).attr("data-product-id"),
          content_type: "product_group",
          value: pri,
          quantity: $(this).attr("data-product-qty"),
          currency: "SGD",
        };
        ttqArr.push(ttqObj);
      }),
        ttq && ttq.track("InitiateCheckout", { contents: ttqArr });
    });
  }),
  $(
    "li.site-footer__linklist-item.Careers a, li.mobile-nav__item.mob_nav_item_careers a"
  ).each(function () {
    var a = new RegExp("/" + window.location.host + "/");
    a.test(this.href) || $(this).attr("target", "_blank");
  }),
  $(".download-pdf").on("click", function () {
    $.ajax({
      url: "https://cdn.shopify.com/s/files/1/1595/6213/files/Comex2022-Brochure.pdf",
      method: "GET",
      xhrFields: { responseType: "blob" },
      success: function (data) {
        var a = document.createElement("a"),
          url = window.URL.createObjectURL(data);
        (a.href = url),
          (a.download = "Comex2022-Brochure.pdf"),
          document.body.append(a),
          a.click(),
          a.remove(),
          window.URL.revokeObjectURL(url);
      },
    });
  });
function isTouchScreendevice() {
  if (window.matchMedia("only screen and (max-width: 760px)").matches)
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
isTouchScreendevice()
  ? ($(".box-list-sc .box-wrapper .box-item .content a.abs-link").addClass(
      "touch"
    ),
    $(".box-list-sc .box-wrapper .box-item .content a.abs-link").removeClass(
      "notouch"
    ))
  : ($(".box-list-sc .box-wrapper .box-item .content a.abs-link").removeClass(
      "touch"
    ),
    $(".box-list-sc .box-wrapper .box-item .content a.abs-link").addClass(
      "notouch"
    ));
//# sourceMappingURL=/s/files/1/0703/1498/3651/t/2/assets/theme.js.map?v=1726737543
